webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(257);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(256);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueMoment = __webpack_require__(255);
	
	var _vueMoment2 = _interopRequireDefault(_vueMoment);
	
	var _vueI18n = __webpack_require__(228);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _vueD = __webpack_require__(227);
	
	var _vueD2 = _interopRequireDefault(_vueD);
	
	var _elementUi = __webpack_require__(11);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _en = __webpack_require__(195);
	
	var _en2 = _interopRequireDefault(_en);
	
	__webpack_require__(224);
	
	var _auth = __webpack_require__(8);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _App = __webpack_require__(229);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Login = __webpack_require__(233);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Dashboard = __webpack_require__(231);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Overview = __webpack_require__(234);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	var _Splash = __webpack_require__(235);
	
	var _Splash2 = _interopRequireDefault(_Splash);
	
	var _Surveillance = __webpack_require__(236);
	
	var _Surveillance2 = _interopRequireDefault(_Surveillance);
	
	var _Clients = __webpack_require__(230);
	
	var _Clients2 = _interopRequireDefault(_Clients);
	
	var _ClientService = __webpack_require__(167);
	
	var _ClientService2 = _interopRequireDefault(_ClientService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.CONFIG = {};
	
	window.CONFIG.api = 'http://52.60.162.95:8080';
	window.CONFIG.host = 'http://52.60.162.95';
	window.CONFIG.authHost = 'http://52.60.162.95:8082/auth';
	
	window.CONFIG.loginCallbackUrl = window.CONFIG.host + '/token/';
	window.CONFIG.authServerUrl = window.CONFIG.authHost + '/oauth/authorize?response_type=token&client_id=rest&redirect_uri=' + window.CONFIG.loginCallbackUrl;
	
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vueMoment2.default);
	_vue2.default.use(_vueD2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_ClientService2.default);
	
	_vue2.default.locale('en', _en2.default);
	
	_vue2.default.http.headers.common['Access-Control-Allow-Origin'] = '*';
	_vue2.default.http.options.xhr = { withCredentials: true };
	_vue2.default.http.interceptors.push(function (request, next) {
	  if (_auth2.default.loggedIn()) {
	    request.headers.set('X-CSRF-TOKEN', _auth2.default.getToken());
	    request.headers.set('Authorization', 'Bearer ' + _auth2.default.getToken());
	  }
	
	  request.headers.set('cache-control', 'no-cache');
	
	  next(function (response) {
	    if (response.status === 401) {
	      _auth2.default.logout(function () {
	        window.location = '/';
	      });
	    }
	    return response;
	  });
	});
	
	function requireAuth(to, from, next) {
	  if (!_auth2.default.loggedIn()) {
	    window.location = window.CONFIG.authServerUrl;
	  } else {
	    next();
	  }
	}
	
	function getQueryVariable(query, variable) {
	  var vars = query.split('&');
	  var result = {};
	  for (var i = 0; i < vars.length; i++) {
	    var pair = vars[i].split('=');
	    result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	
	  return result;
	}
	
	function updateToken(to, from, next) {
	
	  var tokenObj = getQueryVariable(to.hash.substring(1));
	  console.log((0, _stringify2.default)(tokenObj, ' ', 2));
	  _auth2.default.updateTokens(tokenObj.access_token, tokenObj.refresh_token);
	  next({
	    path: '/'
	  });
	}
	
	var router = new _vueRouter2.default({
	  hashbang: false,
	  mode: 'history',
	  root: '/',
	  routes: [{ path: '/overview', component: _Overview2.default, beforeEnter: requireAuth }, { path: '/splash', component: _Dashboard2.default, beforeEnter: requireAuth }, { path: '/', component: _Splash2.default, beforeEnter: requireAuth }, { path: '/surveillance', component: _Surveillance2.default, beforeEnter: requireAuth }, { path: '/token', beforeEnter: updateToken }, { path: '/login', component: _Login2.default }, { path: '/clients', component: _Clients2.default, beforeEnter: requireAuth }]
	});
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  },
	  router: router
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  updateTokens: function updateTokens(accessToken, refreshToken) {
	    localStorage.token = accessToken;
	    localStorage.refresh_token = refreshToken;
	  },
	  getToken: function getToken() {
	    return localStorage.token;
	  },
	  logout: function logout(cb) {
	    delete localStorage.token;
	    window.location = window.CONFIG.authHost + '/logout.do?redirect=' + window.CONFIG.host;
	  },
	  loggedIn: function loggedIn() {
	    return !!localStorage.token;
	  },
	  onChange: function onChange() {}
	};

/***/ },
/* 9 */,
/* 10 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(211)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(177),
	  /* template */
	  __webpack_require__(243),
	  /* scopeId */
	  "data-v-330932a7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(217)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(176),
	  /* template */
	  __webpack_require__(248),
	  /* scopeId */
	  "data-v-6b8384a7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(222)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(178),
	  /* template */
	  __webpack_require__(253),
	  /* scopeId */
	  "data-v-d4850880",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(219)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(179),
	  /* template */
	  __webpack_require__(250),
	  /* scopeId */
	  "data-v-720d8c48",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(210)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(180),
	  /* template */
	  __webpack_require__(242),
	  /* scopeId */
	  "data-v-2bbbb414",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(223)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(181),
	  /* template */
	  __webpack_require__(254),
	  /* scopeId */
	  "data-v-e2b96a24",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(213)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(182),
	  /* template */
	  __webpack_require__(245),
	  /* scopeId */
	  "data-v-47677520",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(208)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(183),
	  /* template */
	  __webpack_require__(240),
	  /* scopeId */
	  "data-v-1aa4073c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._Vue = undefined;
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Vue = exports._Vue = void 0;
	
	var ClientService = {
	  install: function install(Vue, options) {
	    Vue.mixin({
	      data: function data() {
	        return {
	          clients: []
	        };
	      },
	      created: function created() {},
	
	      methods: {
	        loadClients: function loadClients() {
	          var vm = this;
	
	          this.$http.get(window.CONFIG.api + '/clients').then(function (response) {
	            if (response.body) {
	              vm.clients = response.body['_embedded'].clients;
	              console.log((0, _stringify2.default)(vm.clients, ' ', 2));
	            } else {
	              console.log('no content');
	              vm.clients = [];
	            }
	          }, function (response) {});
	        }
	      }
	    });
	  }
	};
	
	exports.default = ClientService;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(8);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      activeIndex: '/'
	    };
	  },
	  methods: {
	    loggedIn: function loggedIn() {
	      return _auth2.default.loggedIn();
	    },
	    logout: function logout() {
	      var vm = this;
	      _auth2.default.logout(function () {
	        console.log('hi');
	        vm.activeIndex = '/';
	        vm.$router.go('/');
	      });
	    },
	    handleTopOpen: function handleTopOpen(key, keyPath) {
	      console.log(key, keyPath);
	    },
	    handleOpen: function handleOpen(key, keyPath) {
	      console.log(key, keyPath);
	    },
	    handleClose: function handleClose(key, keyPath) {
	      console.log(key, keyPath);
	    },
	
	    reload: function reload() {
	      this.$router.go(this.$router.currentRoute);
	    }
	  },
	  created: function created() {
	    this.activeIndex = this.$router.currentRoute.path;
	  }
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _auth = __webpack_require__(8);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _SurveillanceCaseDetail = __webpack_require__(21);
	
	var _SurveillanceCaseDetail2 = _interopRequireDefault(_SurveillanceCaseDetail);
	
	var _SurveillanceCommunication = __webpack_require__(139);
	
	var _SurveillanceCommunication2 = _interopRequireDefault(_SurveillanceCommunication);
	
	var _SurveillanceBiology = __webpack_require__(138);
	
	var _SurveillanceBiology2 = _interopRequireDefault(_SurveillanceBiology);
	
	var _SurveillanceDevice = __webpack_require__(140);
	
	var _SurveillanceDevice2 = _interopRequireDefault(_SurveillanceDevice);
	
	var _SurveillanceSymptoms = __webpack_require__(143);
	
	var _SurveillanceSymptoms2 = _interopRequireDefault(_SurveillanceSymptoms);
	
	var _SurveillanceTreatment = __webpack_require__(144);
	
	var _SurveillanceTreatment2 = _interopRequireDefault(_SurveillanceTreatment);
	
	var _SurveillancePersonalInfo = __webpack_require__(141);
	
	var _SurveillancePersonalInfo2 = _interopRequireDefault(_SurveillancePersonalInfo);
	
	var _SurveillancePrecaution = __webpack_require__(142);
	
	var _SurveillancePrecaution2 = _interopRequireDefault(_SurveillancePrecaution);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  name: 'clients',
	  components: {
	    'surveillance-case-detail': _SurveillanceCaseDetail2.default,
	    'surveillance-communication': _SurveillanceCommunication2.default,
	    'surveillance-biology': _SurveillanceBiology2.default,
	    'surveillance-device': _SurveillanceDevice2.default,
	    'surveillance-symptoms': _SurveillanceSymptoms2.default,
	    'surveillance-treatment': _SurveillanceTreatment2.default,
	    'surveillance-personal-info': _SurveillancePersonalInfo2.default,
	    'surveillance-precaution': _SurveillancePrecaution2.default
	  },
	  data: function data() {
	    return {
	      currentDate: new Date(),
	      cases: [],
	      precautions: [],
	      beds: {},
	      symptomTypes: [],
	      searchNameInput: '',
	      clients: []
	    };
	  },
	  methods: {
	    loadPrecautions: function loadPrecautions() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/precautions/').then(function (response) {
	        vm.precautions = response.body['_embedded'].precautions;
	        vm.loadUnits();
	      }, function (response) {});
	    },
	    loadUnits: function loadUnits() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/units', {
	        headers: {
	          'Authorization': 'Bearer ' + _auth2.default.getToken()
	        }
	      }).then(function (response) {
	        vm.units = response.body['_embedded'].units;
	        vm.graphConfig = { units: vm.units };
	
	        if (vm.selectedUnit === null && vm.units && vm.units.length > 0) {
	          vm.selectedUnit = vm.units[0].value;
	        }
	
	        vm.units.forEach(function (u) {
	          vm.loadRooms(u);
	        });
	      });
	    },
	    loadRooms: function loadRooms(unit) {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/units/' + unit.id + '/rooms').then(function (response) {
	        var rooms = response.body['_embedded'].rooms;
	        rooms.forEach(function (room) {
	          var beds = room.beds;
	          beds.forEach(function (bed) {
	            console.log((0, _stringify2.default)(bed));
	            vm.beds[bed.occId] = {
	              displayText: room.displayText + '-' + bed.displayText,
	              bed: bed
	            };
	            console.log(vm.beds[bed.occId].displayText);
	          });
	        });
	
	        vm.loadClients();
	      }, function (response) {});
	    },
	    clientName: function clientName(clientData) {
	      var firstName = clientData.firstName ? clientData.firstName + ' ' : '';
	      var middleName = clientData.middleName ? clientData.middleName + ' ' : '';
	      var lastName = clientData.lastName ? clientData.lastName : '';
	
	      return firstName + middleName + lastName;
	    },
	    loadClients: function loadClients() {
	      var vm = this;
	
	      this.$http.get(window.CONFIG.api + '/clients').then(function (response) {
	        if (response.body) {
	          vm.clients = response.body['_embedded'].clients;
	        } else {
	          console.log('no content');
	          vm.clients = [];
	        }
	      }, function (response) {});
	    },
	    photoUrl: function photoUrl(f) {
	      return '/static/' + f + '.png';
	    },
	    precautionById: function precautionById(precautionId) {
	      var name = '';
	      this.precautions.forEach(function (p) {
	        if (p.id === precautionId) {
	          name = p.displayText;
	        }
	      });
	
	      return name;
	    },
	    unitById: function unitById(unitId) {
	      var unitName = '';
	      this.units.forEach(function (u) {
	        if (u.id === unitId) {
	          unitName = u.displayText;
	        }
	      });
	
	      return unitName;
	    },
	    nameFilter: function nameFilter(clients) {
	      var vm = this;
	      return clients.filter(function (client) {
	        return vm.clientName(client).toLowerCase().includes(vm.searchNameInput.toLowerCase());
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.loadPrecautions();
	  }
	};

/***/ },
/* 170 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dashboard',
	  data: function data() {
	    return {
	      currentDate: new Date(),
	      cases: [],
	      searchNameInput: '',
	      photos: {},
	      origins: [{
	        value: 'Not Selected',
	        label: 'Not Selected'
	      }, {
	        value: 'HAI',
	        label: 'HAI'
	      }, {
	        value: 'Community Acquired',
	        label: 'Community Acquired'
	      }]
	    };
	  },
	  methods: {
	    loadCases: function loadCases() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/symptomDetails/').then(function (response) {
	        vm.cases = response.body['_embedded'].symptomDetails;
	        vm.cases.forEach(function (c) {
	          if (c.origin == null) {
	            c.origin = 'Not Selected';
	          }
	          c.symptoms.sort(function (a, b) {
	            return a.colorCode > b.colorCode;
	          });
	          vm.loadImage(c);
	        });
	      }, function (response) {});
	    },
	    nameFilter: function nameFilter(cases) {
	      var vm = this;
	      return cases.filter(function (detail) {
	        return detail.name.toLowerCase().includes(vm.searchNameInput.toLowerCase());
	      });
	    },
	    loadImage: function loadImage(detail) {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/clients/' + detail.clientId).then(function (response) {
	        if (response.body['photo']) {
	          var photos = vm.photos;
	          photos[detail.clientId] = '/static/' + response.body['photo'] + '.png';
	          vm.$set(vm.photos, photos);
	          console.log(vm.photos[detail.clientId]);
	          vm.$forceUpdate();
	        }
	      }, function (response) {});
	    },
	    tagType: function tagType(type) {
	      if (type.colorCode === '0') {
	        return 'success';
	      } else if (type.colorCode === '1') {
	        return 'primary';
	      } else if (type.colorCode === '2') {
	        return 'warning';
	      } else if (type.colorCode === '3') {
	        return 'danger';
	      }
	      return 'gray';
	    }
	  },
	  created: function created() {
	    this.loadCases();
	  }
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _fileSaver = __webpack_require__(225);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'inf-case-graph',
	  props: ['range', 'period', 'sites', 'origin', 'confirmed', 'unitId', 'mode', 'config'],
	  data: function data() {
	    return {
	      _svg: null,
	      _d3Data: null,
	      _d3Mounted: false,
	      _period: 'week',
	      _start: Date(),
	      _end: Date(),
	      _sites: { 'GI': true, 'Respiratory': true, 'UTI': true },
	      _types: [],
	      colors: { 'GI': '#00D560', 'Respiratory': '#0080FF', 'UTI': '#FFDE25' },
	      _confirmed: null,
	      _origin: null,
	      _config: null,
	      _unitId: 0,
	      _mode: 'site' };
	  },
	  watch: {
	    range: function range(value) {
	      if (value && value.length > 1) {
	        this._start = value[0];
	        this._end = value[1];
	      }
	      this.reDraw();
	    },
	    period: function period(value) {
	      this._period = value;
	      this.reDraw();
	    },
	    sites: function sites(value) {
	      this._types = value;
	      this.reDraw();
	    },
	    origin: function origin(value) {
	      this._origin = value;
	      this.reDraw();
	    },
	    confirmed: function confirmed(value) {
	      this._confirmed = value;
	      this.reDraw();
	    },
	    config: function config(value) {
	      this._config = value;
	    },
	    unitId: function unitId(value) {
	      this._unitId = value;
	      this.reDraw();
	    },
	    mode: function mode(value) {
	      this._mode = value;
	      this.reDraw();
	    }
	  },
	  methods: {
	    reDraw: function reDraw() {
	      this._svg.remove();
	      this.randerGraph();
	    },
	    loadData: function loadData(callback) {
	      if (!this._start) {
	        return;
	      }
	      var vm = this;
	      var url = window.CONFIG.api + '/symptomDetail/byDays?start=' + this._start + '&end=' + this._end;
	      if (this._confirmed) {
	        url = url + '&confirmed=' + this._confirmed;
	      }
	
	      if (this._origin) {
	        url = url + '&origin=' + this._origin;
	      }
	
	      if (this._unitId > 0) {
	        url = url + '&unit=' + this._unitId;
	      }
	
	      this.$http.get(url).then(function (response) {
	        console.log((0, _stringify2.default)(response.body, ' ', 2));
	        var data = response.body;
	        vm._d3Data = data;
	        callback(data);
	      }, function (response) {});
	    },
	    getDateHandler: function getDateHandler() {
	      var vm = this;
	      var d3 = this.$d3;
	
	      var handler = {
	        formatter: function formatter(d) {
	          var formatted = d3.timeFormat('%W-%Y')(d);
	          return formatted;
	        },
	        parser: function parser(d) {
	          var date = d3.timeParse('%W-%Y')(d);
	          return date;
	        },
	        ticks: d3.timeMonday.every(1),
	        tickFormat: d3.timeFormat('W%W-%Y'),
	        xDomain: function xDomain(minDate, maxDate) {
	          return [minDate, maxDate];
	        }
	      };
	
	      if (vm._period === 'year') {
	        handler = {
	          formatter: d3.timeFormat('%Y'),
	          parser: d3.timeParse('%Y'),
	          ticks: d3.timeYear.every(1),
	          tickFormat: d3.timeFormat('%Y'),
	          xDomain: function xDomain(minDate, maxDate) {
	            return [minDate, maxDate];
	          }
	        };
	      } else if (vm._period === 'quarter') {
	        var quarterFormatter = function quarterFormatter(date) {
	          var q = Math.ceil((date.getMonth() + 0.5) / 3);
	          return 'Q' + q + '-' + date.getFullYear();
	        };
	
	        var quarterParser = function quarterParser(d) {
	          var splitted = d.split('-');
	          var quarterEndMonth = splitted[0].charAt(1) * 3 - 2;
	          var parser = d3.timeParse('%m %Y');
	          return parser(quarterEndMonth + ' ' + splitted[1]);
	        };
	
	        handler = {
	          formatter: function formatter(date) {
	            return quarterFormatter(date);
	          },
	          parser: function parser(d) {
	            return quarterParser(d);
	          },
	          ticks: d3.timeMonth.every(3),
	          tickFormat: function tickFormat(date, i) {
	            return quarterFormatter(date);
	          },
	          xDomain: function xDomain(minDate, maxDate) {
	            return [minDate, maxDate];
	          }
	        };
	      } else if (vm._period === 'month') {
	        handler = {
	          formatter: d3.timeFormat('%Y-%m'),
	          parser: d3.timeParse('%Y-%m'),
	          ticks: d3.timeMonth.every(1),
	          tickFormat: d3.timeFormat('%b-%Y'),
	          xDomain: function xDomain(minDate, maxDate) {
	            return [minDate, maxDate];
	          }
	        };
	      } else if (vm._period === 'week') {}
	
	      return handler;
	    },
	    randerGraph: function randerGraph() {
	      var vm = this;
	      var d3 = this.$d3;
	      var margin = { top: 30, right: 30, bottom: 60, left: 50 };
	      var dateHandler = vm.getDateHandler();
	      var dateFormatter = dateHandler.formatter;
	      var dateParser = dateHandler.parser;
	
	      this._svg = d3.select(this.$el).insert('svg');
	
	      var svg = this._svg;
	      var width = this.$el.clientWidth - margin.left - margin.right;
	      var height = this.$el.clientHeight - margin.top - margin.bottom;
	      svg.attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom);
	
	      var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	      var parseTime = d3.timeParse('%Y-%m-%d');
	
	      var x = d3.scaleTime().rangeRound([0, width]);
	
	      var y = d3.scaleLinear().rangeRound([height, 0]);
	
	      this.loadData(function (data) {
	        var filteredData = data.filter(function (d) {
	          var validType = false;
	          if (!vm._types) {
	            vm._types = [];
	          }
	          validType = vm._types.length === 0;
	
	          vm._types.forEach(function (t) {
	            if (t === d.symptomType) {
	              validType = true;
	            }
	          });
	
	          return validType;
	        });
	        var freqByType = d3.nest().key(function (d) {
	          d.onSetDate = parseTime(d.onSetDate);
	
	          if (vm._mode === 'site') {
	            return d.symptomType;
	          } else if (vm._mode === 'unit') {
	            return d.unitId;
	          }
	
	          return d.symptomType;
	        }).entries(filteredData);
	
	        g.append('text').attr('text-anchor', 'middle').attr('transform', 'translate(' + -30 + ',' + height / 2 + ')rotate(-90)').text('Frequency');
	
	        g.append('text').attr('text-anchor', 'middle').attr('transform', 'translate(' + width / 2 + ',' + (height + margin.bottom - 15) + ')').text('Onset Date');
	
	        var processedData = [];
	
	        freqByType.forEach(function (dataGroup, index) {
	          var data = d3.nest().key(function (d) {
	            return dateFormatter(new Date(d.onSetDate));
	          }).rollup(function (v) {
	            return d3.sum(v, function (d) {
	              return d.count;
	            });
	          }).entries(dataGroup.values);
	
	          data.sort(function (x, y) {
	            return d3.ascending(x.onSetDate, y.onSetDate);
	          });
	
	          var groupColor = vm.colors[dataGroup.key];
	          if (!groupColor) {
	            vm.colors[dataGroup.key] = d3.scaleOrdinal(d3.schemeCategory20);
	            groupColor = vm.colors[dataGroup.key];
	          }
	
	          var dataLabel = dataGroup.key;
	          if (vm._mode === 'unit') {
	            vm._config.units.forEach(function (u) {
	              console.log(u.displayText + ', ' + dataGroup.key + ', ' + u.id);
	              console.log(dataGroup.key);
	              console.log(u.id);
	              if (u.id === parseInt(dataGroup.key)) {
	                console.log(u);
	                dataLabel = u.displayText;
	              }
	            });
	          }
	
	          var legend = g.append('g').attr('font-family', 'sans-serif').attr('font-size', 10).attr('text-anchor', 'end').attr('transform', 'translate(0,' + index * 25 + ')');
	
	          legend.append('rect').attr('x', width - 19).attr('width', 18).attr('height', 18).attr('fill', groupColor).style('stroke', 'black').style('stroke-width', 1);
	
	          legend.append('text').attr('x', width - 24).attr('y', 9.5).attr('dy', '0.32em').text(dataLabel);
	
	          data.forEach(function (d) {
	            d.type = dataGroup.key;
	            d.index = index;
	            d.color = groupColor;
	            var tDate = dateParser(d.key);
	            d.date = tDate;
	
	            if (!processedData[d.type]) {
	              processedData[d.type] = {};
	              processedData[d.type]['values'] = [];
	              processedData[d.type].color = groupColor;
	            }
	            processedData[d.type]['values'].push(d);
	          });
	        });
	
	        var minDate = new Date();
	        var maxDate = new Date();
	
	        if (vm.range && vm.range[0] && vm.range[1]) {
	          minDate = vm.range[0];
	          maxDate = vm.range[1];
	        }
	
	        minDate = dateParser(dateFormatter(minDate));
	        maxDate = dateParser(dateFormatter(maxDate));
	
	        x.domain(dateHandler.xDomain(minDate, maxDate));
	
	        var maxValue = 0;
	        for (var p in processedData) {
	          if (processedData[p] && processedData[p].values) {
	            var tMax = d3.max(processedData[p].values, function (d) {
	              return d.value;
	            });
	
	            if (tMax > maxValue) {
	              maxValue = tMax;
	            }
	          }
	        }
	
	        var newData = {};
	        x.ticks(dateHandler.ticks).map(function (bucket) {
	          var key = dateFormatter(bucket);
	          for (p in processedData) {
	            if (processedData[p] && processedData[p].values) {
	              var init = processedData[p].values[0];
	              var hasValue = false;
	              var found = init;
	
	              if (!newData[p]) {
	                newData[p] = {};
	                newData[p]['values'] = [];
	                newData[p].color = vm.colors[init.type];
	                if (!newData[p].color) {
	                  vm.colors[init.type] = d3.scaleOrdinal(d3.schemeCategory20);
	                  newData[p].color = vm.colors[init.type];
	                }
	              }
	
	              processedData[p].values.forEach(function (d) {
	                if (d.key === key) {
	                  hasValue = true;
	                  found = d;
	                }
	              });
	
	              if (!hasValue) {
	                var nD = {
	                  key: key,
	                  type: init.type,
	                  index: init.index,
	                  color: init.color,
	                  date: dateParser(key),
	                  value: 0
	                };
	
	                newData[p].values.push(nD);
	              } else {
	                newData[p].values.push(found);
	              }
	            }
	          }
	
	          return bucket;
	        });
	
	        var yMax = maxValue + maxValue / 2;
	        if (yMax < 5) {
	          yMax = 5;
	        }
	        y.domain([0, yMax]);
	
	        for (p in processedData) {
	          if (processedData[p] && processedData[p].values) {
	            processedData[p].values.sort(function (x, y) {
	              return d3.ascending(x.date, y.date);
	            });
	          }
	        }
	        processedData = newData;
	
	        g.append('g').attr('class', 'x-axis').attr('transform', 'translate(0,' + height + ')').call(d3.axisBottom(x).ticks(dateHandler.ticks).tickFormat(dateHandler.tickFormat));
	
	        g.append('g').call(d3.axisLeft(y).ticks(3)).append('text').attr('fill', '#000').attr('x', 6).attr('dy', '-3em').attr('text-anchor', 'center').text('Case');
	
	        var lineGen = d3.line().curve(d3.curveCardinal.tension(0.8)).x(function (d) {
	          return x(d.date);
	        }).y(function (d) {
	          return y(d.value);
	        });
	
	        function makeXgridlines() {
	          return d3.axisBottom(x).ticks(10);
	        }
	
	        function makeYgridlines() {
	          return d3.axisLeft(y).ticks(10);
	        }
	
	        g.append('g').attr('class', 'grid').attr('transform', 'translate(0,' + height + ')').style('opacity', '0.1').call(makeXgridlines().tickSize(-height).tickFormat(''));
	
	        g.append('g').attr('class', 'grid').style('opacity', '0.1').call(makeYgridlines().tickSize(-width).tickFormat(''));
	
	        for (var prop in processedData) {
	          processedData[prop].values.forEach(function (d) {
	            g.append('circle').attr('class', 'circle').filter(function () {
	              return d.date >= minDate && d.date <= maxDate;
	            }).attr('cx', x(d.date)).attr('cy', y(d.value)).attr('r', 3).attr('width', 16).attr('fill', d.color).style('stroke', d.color).style('stroke-width', 1).attr('height', height - y(d.value));
	          });
	
	          g.append('path').attr('class', 'line').attr('d', lineGen(processedData[prop].values)).attr('stroke', processedData[prop].color).attr('stroke-width', 2).attr('fill', 'none');
	        }
	
	        var mouseG = g.append('g').attr('class', 'mouse-over-effects');
	
	        mouseG.append('path').attr('class', 'mouse-line').style('stroke', '#454544').style('stroke-width', '1px').style('opacity', '0');
	
	        var lines = document.getElementsByClassName('line');
	        for (prop in processedData) {
	          var d = processedData[prop];
	          var mousePerLine = mouseG.append('g').attr('class', 'mouse-per-line');
	
	          mousePerLine.append('circle').attr('r', 7).style('stroke', d.color).style('fill', 'none').style('stroke-width', '1px').style('opacity', '0');
	
	          mousePerLine.append('text').attr('transform', 'translate(10,3)');
	        }
	
	        mouseG.append('svg:rect').attr('width', width).attr('height', height).attr('fill', 'none').attr('pointer-events', 'all').on('mouseout', function () {
	          d3.select('.mouse-line').style('opacity', '0');
	          d3.selectAll('.mouse-per-line circle').style('opacity', '0');
	          d3.selectAll('.mouse-per-line text').style('opacity', '0');
	        }).on('mouseover', function () {
	          d3.select('.mouse-line').style('opacity', '1');
	          d3.selectAll('.mouse-per-line circle').style('opacity', '1');
	          d3.selectAll('.mouse-per-line text').style('opacity', '1');
	        }).on('mousemove', function () {
	          var mouse = d3.mouse(this);
	          d3.select('.mouse-line').attr('d', function () {
	            var d = 'M' + mouse[0] + ',' + height;
	            d += ' ' + mouse[0] + ',' + 0;
	            return d;
	          });
	
	          d3.selectAll('.mouse-per-line').attr('transform', function (d, i) {
	
	            var beginning = 0;
	            var end = lines[i].getTotalLength();
	            var target = null;
	            var pos = null;
	
	            while (true) {
	              target = Math.floor((beginning + end) / 2);
	              pos = lines[i].getPointAtLength(target);
	              if ((target === end || target === beginning) && pos.x !== mouse[0]) {
	                break;
	              }
	              if (pos.x > mouse[0]) {
	                end = target;
	              } else if (pos.x < mouse[0]) {
	                beginning = target;
	              } else {
	                break;
	              }
	            }
	
	            d3.select(this).select('text').text(y.invert(pos.y).toFixed(0));
	
	            return 'translate(' + mouse[0] + ',' + pos.y + ')';
	          });
	        });
	
	        var maxTicks = Math.floor(width / 60);
	        var currTicks = x.ticks(dateHandler.ticks).length;
	        if (currTicks > maxTicks) {
	          var factor = Math.ceil(currTicks / maxTicks);
	          d3.selectAll('g.x-axis g.tick').each(function (d, i) {
	            if (i % factor > 0) {
	              this.remove();
	            }
	          });
	        }
	      });
	    },
	    exportGraph: function exportGraph() {
	      var d3 = this.$d3;
	      var svgNode = d3.select('svg');
	      var width = svgNode.attr('width');
	      var height = svgNode.attr('height');
	      var svgString = this.getSVGString(this.$el.querySelector('svg'));
	      this.svgString2Image(svgString, 2 * width, 2 * height, 'png', save);
	
	      function save(dataBlob, filesize) {
	        var timeFormatter = d3.timeFormat('%Y-%m-%d-%H-%M-%S');
	        _fileSaver2.default.saveAs(dataBlob, 'graph-' + timeFormatter(new Date()) + '.png');
	      }
	    },
	    getSVGString: function getSVGString(svgNode) {
	      svgNode.setAttribute('xlink', 'http://www.w3.org/1999/xlink');
	      var cssStyleText = getCSSStyles(svgNode);
	      console.log(cssStyleText);
	      console.log(_fileSaver2.default);
	
	
	      var serializer = new window.XMLSerializer();
	      var svgString = serializer.serializeToString(svgNode);
	      svgString = svgString.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink=');
	      svgString = svgString.replace(/NS\d+:href/g, 'xlink:href');
	      console.log(svgString);
	      return svgString;
	
	      function getCSSStyles(parentElement) {
	        var selectorTextArr = [];
	
	        selectorTextArr.push('#' + parentElement.id);
	        console.log(parentElement.classList);
	        if (parentElement.classList) {
	          for (var c = 0; c < parentElement.classList.length; c++) {
	            if (!contains('.' + parentElement.classList[c], selectorTextArr)) {
	              selectorTextArr.push('.' + parentElement.classList[c]);
	            }
	          }
	        }
	
	        var nodes = parentElement.getElementsByTagName('*');
	
	        for (var i = 0; i < nodes.length; i++) {
	          var id = nodes[i].id;
	          if (!contains('#' + id, selectorTextArr)) {
	            selectorTextArr.push('#' + id);
	          }
	
	          var classes = nodes[i].classList || [];
	          for (c = 0; c < classes.length; c++) {
	            if (!contains('.' + classes[c], selectorTextArr)) {
	              selectorTextArr.push('.' + classes[c]);
	            }
	          }
	        }
	
	        var extractedCSSText = '';
	
	        for (i = 0; i < document.styleSheets.length; i++) {
	          var s = document.styleSheets[i];
	          try {
	            if (!s.cssRules) continue;
	          } catch (e) {
	            if (e.name !== 'SecurityError') throw e;
	            continue;
	          }
	
	          var cssRules = s.cssRules;
	          for (var r = 0; r < cssRules.length; r++) {
	            if (contains(cssRules[r].selectorText, selectorTextArr)) {
	              extractedCSSText += cssRules[r].cssText;
	            }
	          }
	        }
	        return extractedCSSText;
	      }
	
	      function contains(str, arr) {
	        return arr.indexOf(str) !== -1;
	      }
	    },
	    svgString2Image: function svgString2Image(svgString, width, height, format, callback) {
	      if (!format) {
	        format = 'png';
	      }
	
	      var imgsrc = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(svgString)));
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = width;
	      canvas.height = height;
	
	      var image = new window.Image();
	      image.setAttribute('crossOrigin', 'anonymous');
	      image.onload = function () {
	        context.clearRect(0, 0, width, height);
	        context.drawImage(image, 0, 0, width, height);
	
	        canvas.toBlob(function (blob) {
	          var filesize = Math.round(blob.length / 1024) + ' KB';
	          if (callback) callback(blob, filesize);
	        });
	      };
	      image.src = imgsrc;
	    },
	    handleResize: function handleResize() {
	      this.reDraw();
	    }
	  },
	  mounted: function mounted() {
	    this.randerGraph();
	    this._d3Mounted = true;
	    console.log(this.$d3.select('svg').node());
	  },
	  created: function created() {
	    window.addEventListener('resize', this.handleResize);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.handleResize);
	  }
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(8);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'login',
	  data: function data() {
	    return {
	      username: '',
	      pass: '',
	      error: false
	    };
	  },
	
	  methods: {
	    login: function login() {
	      var _this = this;
	
	      _auth2.default.login(this.username, this.pass, function (loggedIn) {
	        if (!loggedIn) {
	          _this.error = true;
	        } else {
	          window.location = '/';
	        }
	      });
	    }
	  }
	};

/***/ },
/* 173 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'overview',
	  data: function data() {
	    return {
	      currentDate: new Date(),
	      cases: [],
	      searchNameInput: ''
	    };
	  },
	  methods: {
	    loadCases: function loadCases() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/symptomDetails/').then(function (response) {
	        vm.cases = response.body['_embedded'].symptomDetails;
	      }, function (response) {});
	    },
	    nameFilter: function nameFilter(cases) {
	      var vm = this;
	      return cases.filter(function (detail) {
	        return detail.name.toLowerCase().includes(vm.searchNameInput.toLowerCase());
	      });
	    },
	    tagType: function tagType(type) {
	      if (type.colorCode === '0') {
	        return 'success';
	      } else if (type.colorCode === '1') {
	        return 'primary';
	      } else if (type.colorCode === '2') {
	        return 'danger';
	      } else if (type.colorCode === '3') {
	        return 'warning';
	      }
	      return 'gray';
	    }
	  },
	  created: function created() {
	    this.loadCases();
	  }
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _InfCaseGraph = __webpack_require__(232);
	
	var _InfCaseGraph2 = _interopRequireDefault(_InfCaseGraph);
	
	var _SymptomCaseDetail = __webpack_require__(237);
	
	var _SymptomCaseDetail2 = _interopRequireDefault(_SymptomCaseDetail);
	
	var _SurveillanceCaseDetail = __webpack_require__(21);
	
	var _SurveillanceCaseDetail2 = _interopRequireDefault(_SurveillanceCaseDetail);
	
	var _auth = __webpack_require__(8);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  name: 'splash',
	  components: {
	    'inf-case-graph': _InfCaseGraph2.default,
	    'symptom-case-detail': _SymptomCaseDetail2.default,
	    'surveillance-case-detail': _SurveillanceCaseDetail2.default
	  },
	  data: function data() {
	    return {
	      initialRun: true,
	      loadingData: true,
	      currentDate: new Date(),
	      cases: [],
	      precautions: [],
	      beds: {},
	      symptomTypes: [],
	      searchNameInput: '',
	      graphConfig: {},
	      graphMode: 'site',
	      clients: {},
	      origins: [{
	        value: 0,
	        label: 'All'
	      }, {
	        value: 'HAI',
	        label: 'HAI'
	      }, {
	        value: 'Community Acquired',
	        label: 'Community Acquired'
	      }],
	      statusImageMap: {
	        'GI': 'bug2',
	        'UTI': 'bug3',
	        'Respiratory': 'bug1'
	      },
	      selectedCase: null,
	      selectedUnit: 0,
	      selectedOrigin: 0,
	      dialogFormVisible: false,
	      selectedStatus: 0,
	      symptomDetailPage: 1,
	      symptomDetailPageSize: 10,
	      symptomDetailPageTotal: 0,
	      symptomDetailPageSizeOptions: [{
	        label: '5 items per page',
	        value: 5
	      }, {
	        label: '10 items per page',
	        value: 10
	      }, {
	        label: '20 items per page',
	        value: 20
	      }, {
	        label: '50 items per page',
	        value: 50
	      }],
	      filterDateRange: '',
	      filteredSite: {},
	      filterPeriods: 'week',
	      filterSymptomTypes: [],
	      filterConfirmStatus: null,
	      filterOrigin: null,
	      organisms: [],
	      treatments: [],
	      units: [],
	      graphPeriodFilter: 'By Week',
	      graphDisplayFilter: 'By Infection Site',
	      pickerOptions: {
	        shortcuts: [{
	          text: 'Last week',
	          onClick: function onClick(picker) {
	            var end = (0, _moment2.default)().weekday(-1).hours(23).minutes(59).toDate();
	            console.log(end);
	            var start = (0, _moment2.default)().weekday(-7).toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Last month',
	          onClick: function onClick(picker) {
	            var lastMonth = (0, _moment2.default)().subtract(1, 'months');
	            var end = lastMonth.endOf('month').toDate();
	            var start = lastMonth.startOf('month').toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Last year',
	          onClick: function onClick(picker) {
	            var lastYear = (0, _moment2.default)().subtract(1, 'years');
	            var end = lastYear.endOf('year').toDate();
	            var start = lastYear.startOf('year').toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Current week',
	          onClick: function onClick(picker) {
	            var end = (0, _moment2.default)().weekday(6).add(1, 'days').subtract(1, 'minutes').toDate();
	            var start = (0, _moment2.default)().weekday(0).toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Current month',
	          onClick: function onClick(picker) {
	            var lastMonth = (0, _moment2.default)();
	            var end = lastMonth.endOf('month').toDate();
	            var start = lastMonth.startOf('month').toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Current year',
	          onClick: function onClick(picker) {
	            var end = (0, _moment2.default)().endOf('year').toDate();
	            var start = (0, _moment2.default)().startOf('year').toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }]
	      }
	    };
	  },
	  methods: {
	    exportExcel: function exportExcel() {
	      console.log('exportExcel clicked');
	      var unitId = this.selectedUnit;
	      var after = this.filterDateRange[0];
	      var before = this.filterDateRange[1];
	      var rUrl = window.CONFIG.api + '/symptomDetail/unit/' + unitId + '/export/excel/' + '?start=' + after + '&end=' + before;
	      rUrl = rUrl + '&types=' + this.filterSymptomTypes;
	
	      if (this.selectedOrigin !== 0) {
	        rUrl = rUrl + '&origin=' + this.selectedOrigin;
	      }
	
	      if (this.selectedStatus !== 0) {
	        rUrl = rUrl + '&confirmed=' + (this.selectedStatus === 1 ? 'true' : 'false');
	      }
	
	      this.$http.get(rUrl).then(function (response) {
	        console.log((0, _stringify2.default)(response, ' ', 2));
	        var headers = response.headers.map;
	        var blob = new window.Blob([response.data], { type: headers['content-type'] });
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'report.xls';
	        link.click();
	      });
	    },
	    loadCases: function loadCases() {
	      var vm = this;
	      this.loadingData = true;
	      var unitId = this.selectedUnit;
	      var after = this.filterDateRange[0];
	      var before = this.filterDateRange[1];
	
	      var rUrl = window.CONFIG.api + '/symptomDetail/unit/' + unitId + '/page/' + (vm.symptomDetailPage - 1) + '?size=' + vm.symptomDetailPageSize + '&start=' + after + '&end=' + before;
	      rUrl = rUrl + '&types=' + this.filterSymptomTypes;
	
	      if (this.selectedOrigin !== 0) {
	        rUrl = rUrl + '&origin=' + this.selectedOrigin;
	      }
	
	      if (this.selectedStatus !== 0) {
	        rUrl = rUrl + '&confirmed=' + (this.selectedStatus === 1 ? 'true' : 'false');
	      }
	
	      this.$http.get(rUrl).then(function (response) {
	        if (response.body && response.body['content'].length > 0) {
	          var cases = response.body['content'];
	          var callbackCounter = 0;
	
	          vm.symptomDetailPageTotal = response.body['totalPages'];
	          cases.forEach(function (c) {
	            if (c.origin == null) {
	              c.origin = 0;
	            }
	            c.symptoms.sort(function (a, b) {
	              return a.colorCode > b.colorCode;
	            });
	            vm.loadImage(c, function () {
	              callbackCounter++;
	              if (callbackCounter >= cases.length) {
	                vm.cases = cases;
	              }
	            });
	          });
	        } else {
	          console.log('no content');
	          vm.cases = [];
	        }
	
	        vm.loadingData = false;
	      }, function (response) {});
	
	      if (this.initialRun) {
	        this.initialRun = false;
	        vm.$watch('graphPeriodFilter', function (val) {
	          if (vm.graphPeriodFilter === 'By Year') {
	            vm.filterPeriods = 'year';
	          } else if (vm.graphPeriodFilter === 'By Quarter') {
	            vm.filterPeriods = 'quarter';
	          } else if (vm.graphPeriodFilter === 'By Month') {
	            vm.filterPeriods = 'month';
	          } else if (vm.graphPeriodFilter === 'By Week') {
	            vm.filterPeriods = 'week';
	          }
	        });
	
	        vm.$watch('graphDisplayFilter', function (val) {
	          console.log(val);
	          if (vm.graphDisplayFilter === 'By Unit') {
	            vm.graphMode = 'unit';
	          } else {
	            vm.graphMode = 'site';
	          }
	        });
	
	        vm.$watch('symptomDetailPageSize', function (val) {
	          vm.symptomDetailPage = 1;
	          vm.loadCases();
	        });
	      }
	    },
	    loadOrganisms: function loadOrganisms() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/organisms/').then(function (response) {
	        vm.organisms = response.body['_embedded'].organisms;
	        vm.loadPrecautions();
	      }, function (response) {});
	    },
	    loadPrecautions: function loadPrecautions() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/precautions/').then(function (response) {
	        vm.precautions = response.body['_embedded'].precautions;
	        vm.loadTreatments();
	      }, function (response) {});
	    },
	    loadTreatments: function loadTreatments() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/treatments/').then(function (response) {
	        vm.treatments = response.body['_embedded'].treatments;
	        vm.loadCases();
	      }, function (response) {});
	    },
	    loadUnits: function loadUnits() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/units', {
	        headers: {
	          'Authorization': 'Bearer ' + _auth2.default.getToken()
	        }
	      }).then(function (response) {
	        vm.units = response.body['_embedded'].units;
	        vm.graphConfig = { units: vm.units };
	
	        if (vm.selectedUnit === null && vm.units && vm.units.length > 0) {
	          vm.selectedUnit = vm.units[0].value;
	        }
	
	        vm.units.forEach(function (u) {
	          vm.loadRooms(u);
	        });
	
	        vm.loadSymptomTypes();
	      });
	    },
	    loadRooms: function loadRooms(unit) {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/units/' + unit.id + '/rooms').then(function (response) {
	        var rooms = response.body['_embedded'].rooms;
	        rooms.forEach(function (room) {
	          var beds = room.beds;
	          beds.forEach(function (bed) {
	            vm.beds[bed.id] = room.displayText + '-' + bed.displayText;
	          });
	        });
	      }, function (response) {});
	    },
	    loadSymptomTypes: function loadSymptomTypes() {
	      var vm = this;
	
	      this.symptomTypes = [];
	      this.$http.get(window.CONFIG.api + '/symptoms/classtypes').then(function (response) {
	        var newTypes = response.body;
	        if (newTypes && newTypes.length > 0) {
	          vm.symptomTypes.push({ 'text': 'All Infection Site', 'value': 0 });
	          for (var i = 0; i < newTypes.length - 1; i++) {
	            var s = {};
	            s.text = newTypes[i];
	            s.value = i + 1;
	            vm.symptomTypes.push(s);
	          }
	          vm.filteredSite = vm.symptomTypes[0].value;
	          console.log(vm.symptomTypes);
	        }
	        vm.loadOrganisms();
	      });
	    },
	    nameFilter: function nameFilter(cases) {
	      var vm = this;
	      return cases.filter(function (detail) {
	        return detail.name.toLowerCase().includes(vm.searchNameInput.toLowerCase());
	      });
	    },
	    reloadPage: function reloadPage(page) {
	      if (this.symptomDetailPage !== page) {
	        this.symptomDetailPage = page;
	        this.loadCases();
	      }
	    },
	    loadImage: function loadImage(detail, callback) {
	      var vm = this;
	      if (this.clients[detail.clientId] || this.clients[detail.clientId] === false) {
	        callback();
	        return;
	      }
	      this.clients[detail.clientId] = false;
	      this.$http.get(window.CONFIG.api + '/clients/' + detail.clientId).then(function (response) {
	        vm.$set(vm.clients, detail.clientId, response.body);
	        vm.$forceUpdate();
	        callback();
	      }, function (response) {
	        callback();
	      });
	    },
	    statusImage: function statusImage(detail) {
	      if (detail.symptomType) {
	        var filename = this.statusImageMap[detail.symptomType];
	        if (!detail.confirmed) {
	          filename = filename + 's';
	        }
	        return '/static/' + filename + '.png';
	      }
	    },
	    tagType: function tagType(type) {
	      if (type.colorCode === '0') {
	        return 'success';
	      } else if (type.colorCode === '1') {
	        return 'primary';
	      } else if (type.colorCode === '2') {
	        return 'warning';
	      } else if (type.colorCode === '3') {
	        return 'danger';
	      }
	      return 'gray';
	    },
	    selectedRow: function selectedRow(row, event, column) {
	      this.selectedCase = JSON.parse((0, _stringify2.default)(row));
	      if (!this.selectedCase.origin) {
	        this.selectedCase.origin = 0;
	      }
	      console.log((0, _stringify2.default)(this.selectedCase, ' ', 2));
	      console.log((0, _stringify2.default)(this.clients[this.selectedCase.clientId], ' ', 2));
	      this.dialogFormVisible = true;
	    },
	    dateRangeUpdated: function dateRangeUpdated(value) {
	      if (!value) {
	        var end = new Date();
	        var start = new Date();
	        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
	
	        this.filterDateRange = [start, end];
	      } else {
	        var _start = (0, _moment2.default)(this.filterDateRange[0]).hours(0).minutes(0).seconds(0).toDate();
	        var _end = (0, _moment2.default)(this.filterDateRange[1]).hours(23).minutes(59).seconds(59).toDate();
	        console.log(_start);
	        console.log(_end);
	        this.filterDateRange = [_start, _end];
	      }
	
	      this.loadCases();
	    },
	    unitUpdated: function unitUpdated(value) {
	      console.log('unit : ' + value);
	      this.loadCases();
	    },
	    symptomTypeUpdated: function symptomTypeUpdated(value) {
	      var vm = this;
	      var sypmtomTypeFilter = [];
	      if (this.symptomTypes) {
	        this.symptomTypes.forEach(function (s, i) {
	          if ((vm.filteredSite === 0 || vm.filteredSite === s.value) && i !== 0) {
	            sypmtomTypeFilter.push(s.text);
	          }
	        });
	      }
	
	      this.filterSymptomTypes = sypmtomTypeFilter;
	      this.loadCases();
	    },
	    originUpdated: function originUpdated(value) {
	      if (value === 0) {
	        this.filterOrigin = null;
	      } else {
	        this.filterOrigin = value;
	      }
	      console.log('originUpdated:' + value);
	      this.loadCases();
	    },
	    confirmStatusUpdated: function confirmStatusUpdated(value) {
	      console.log('confirmStatusUpdated:' + value);
	      if (value === 0) {
	        this.filterConfirmStatus = null;
	      } else {
	        this.filterConfirmStatus = value === 1 ? 'true' : 'false';
	      }
	      this.loadCases();
	    },
	    organismById: function organismById(organId) {
	      var organName = 'Not Selected';
	      if (organId === 0) {
	        return organName;
	      }
	
	      this.organisms.forEach(function (o) {
	        if (o.id === organId) {
	          organName = o.name;
	        }
	      });
	
	      return organName;
	    },
	    treatmentById: function treatmentById(treatmentId) {
	      var name = 'Not Selected';
	      if (treatmentId === 0) {
	        return name;
	      }
	
	      this.treatments.forEach(function (t) {
	        if (t.id === treatmentId) {
	          name = t.displayText;
	        }
	      });
	
	      return name;
	    },
	    unitById: function unitById(unitId) {
	      var unitName = '';
	      this.units.forEach(function (u) {
	        if (u.id === unitId) {
	          unitName = u.displayText;
	        }
	      });
	
	      return unitName;
	    },
	    originById: function originById(originId) {
	      var originName = 'Not Selected';
	      this.origins.forEach(function (o) {
	        if (o.value === originId && o.value !== 0) {
	          originName = o.label;
	        }
	      });
	      return originName;
	    },
	    unitByName: function unitByName(unitName) {
	      var unit = null;
	      this.units.forEach(function (u) {
	        if (u.displayText === unitName) {
	          unit = u;
	        }
	      });
	
	      return unit;
	    },
	    precautionById: function precautionById(precautionId) {
	      var name = '';
	      this.precautions.forEach(function (p) {
	        if (p.id === precautionId) {
	          name = p.displayText;
	        }
	      });
	
	      return name;
	    },
	    photosUrl: function photosUrl(clientId) {
	      if (this.clients[clientId].photo) {
	        return '/static/' + this.clients[clientId].photo + '.png';
	      }
	
	      return '/static/user.png';
	    },
	    saveSymtomDetail: function saveSymtomDetail(symptomDetail) {
	      var _this = this;
	
	      var vm = this;
	      var caseDetail = JSON.parse((0, _stringify2.default)(symptomDetail));
	      delete caseDetail.id;
	      caseDetail.symptoms.forEach(function (s) {
	        delete s.id;
	      });
	
	      if (caseDetail.origin === 0) {
	        delete caseDetail.origin;
	      }
	
	      var jsonData = (0, _stringify2.default)(caseDetail);
	      this.$http.put(window.CONFIG.api + '/symptomDetails/' + symptomDetail.id, jsonData).then(function (response) {
	        vm.dialogFormVisible = false;
	        vm.selectedCase = null;
	        vm.loadCases();
	      }, function (response) {
	        console.log(response);
	        _this.$message.error('Access Denied');
	      });
	    },
	    reverse: function reverse(array) {
	      return array.slice().reverse();
	    },
	    clientName: function clientName(symptomDetail) {
	      var clientData = this.clients[symptomDetail.clientId];
	      var firstName = clientData.firstName ? clientData.firstName + ' ' : '';
	      var middleName = clientData.middleName ? clientData.middleName + ' ' : '';
	      var lastName = clientData.lastName ? clientData.lastName : '';
	
	      return firstName + middleName + lastName;
	    }
	  },
	  mounted: function mounted() {
	    var lastMonth = (0, _moment2.default)();
	    var end = lastMonth.endOf('month').toDate();
	    var start = lastMonth.startOf('month').toDate();
	    this.filterDateRange = [start, end];
	
	    this.loadUnits();
	  }
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _auth = __webpack_require__(8);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _elementUi = __webpack_require__(11);
	
	var _SurveillanceCaseDetail = __webpack_require__(21);
	
	var _SurveillanceCaseDetail2 = _interopRequireDefault(_SurveillanceCaseDetail);
	
	var _SurveillanceCommunication = __webpack_require__(139);
	
	var _SurveillanceCommunication2 = _interopRequireDefault(_SurveillanceCommunication);
	
	var _SurveillanceBiology = __webpack_require__(138);
	
	var _SurveillanceBiology2 = _interopRequireDefault(_SurveillanceBiology);
	
	var _SurveillanceDevice = __webpack_require__(140);
	
	var _SurveillanceDevice2 = _interopRequireDefault(_SurveillanceDevice);
	
	var _SurveillanceSymptoms = __webpack_require__(143);
	
	var _SurveillanceSymptoms2 = _interopRequireDefault(_SurveillanceSymptoms);
	
	var _SurveillanceTreatment = __webpack_require__(144);
	
	var _SurveillanceTreatment2 = _interopRequireDefault(_SurveillanceTreatment);
	
	var _SurveillancePersonalInfo = __webpack_require__(141);
	
	var _SurveillancePersonalInfo2 = _interopRequireDefault(_SurveillancePersonalInfo);
	
	var _SurveillancePrecaution = __webpack_require__(142);
	
	var _SurveillancePrecaution2 = _interopRequireDefault(_SurveillancePrecaution);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  name: 'surveillance',
	  components: {
	    'surveillance-case-detail': _SurveillanceCaseDetail2.default,
	    'surveillance-communication': _SurveillanceCommunication2.default,
	    'surveillance-biology': _SurveillanceBiology2.default,
	    'surveillance-device': _SurveillanceDevice2.default,
	    'surveillance-symptoms': _SurveillanceSymptoms2.default,
	    'surveillance-treatment': _SurveillanceTreatment2.default,
	    'surveillance-personal-info': _SurveillancePersonalInfo2.default,
	    'surveillance-precaution': _SurveillancePrecaution2.default
	  },
	  data: function data() {
	    return {
	      filterSelectionVisible: false,
	      loading: true,
	      currentDate: new Date(),
	      cases: [],
	      precautions: [],
	      beds: {},
	      symptomTypes: [],
	      symptoms: [],
	      searchNameInput: '',
	      clients: {},
	      clientList: [],
	      clientService: {},
	      origins: [{
	        value: 0,
	        label: 'All'
	      }, {
	        value: 'HAI',
	        label: 'HAI'
	      }, {
	        value: 'Community Acquired',
	        label: 'Community Acquired'
	      }],
	      statusImageMap: {
	        'GI': 'bug2',
	        'UTI': 'bug3',
	        'Respiratory': 'bug1'
	      },
	      allFilters: {
	        dateRange: true,
	        unit: true,
	        infSite: true,
	        status: true,
	        origin: true,
	        precaution: false,
	        organism: false,
	        resolution: false,
	        familyNotified: false,
	        nextOfKinNotified: false,
	        physicianNotified: false,
	        staffOrRes: false,
	        firstName: false,
	        lastName: false
	      },
	      caseActiveTab: '1',
	      selectedCase: null,
	      selectedClient: null,
	      selectedUnit: 0,
	      selectedOrigin: 0,
	      selectedStatus: 0,
	      selectedPrecautions: 0,
	      selectedOrganisms: 0,
	      selectedResolved: 0,
	      selectedFamilyNotified: 0,
	      selectedNextOfNotified: 0,
	      selectedPhysicianNotified: 0,
	      selectedClientType: 0,
	      selectedFirstName: '',
	      selectedLastName: '',
	      dialogFormVisible: false,
	      newCaseDialogFormVisible: false,
	      newCase: {
	        client: null,
	        symptoms: []
	      },
	      symptomDetailPage: 1,
	      symptomDetailPageSize: 10,
	      symptomDetailPageTotal: 0,
	      symptomDetailTotal: 0,
	      filterDateRange: '',
	      filteredSite: {},
	      filterPeriods: 'week',
	      filterSymptomTypes: [],
	      organisms: [],
	      treatments: [],
	      units: [],
	      graphPeriodFilter: 'By Week',
	      graphDisplayFilter: 'By Infection Site',
	      pickerOptions: {
	        shortcuts: [{
	          text: 'Last week',
	          onClick: function onClick(picker) {
	            var end = (0, _moment2.default)().weekday(-1).toDate();
	            var start = (0, _moment2.default)().weekday(-7).toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Last month',
	          onClick: function onClick(picker) {
	            var lastMonth = (0, _moment2.default)().subtract(1, 'months');
	            var end = lastMonth.endOf('month').toDate();
	            var start = lastMonth.startOf('month').toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Last year',
	          onClick: function onClick(picker) {
	            var lastYear = (0, _moment2.default)().subtract(1, 'years');
	            var end = lastYear.endOf('year').toDate();
	            var start = lastYear.startOf('year').toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Current week',
	          onClick: function onClick(picker) {
	            var end = (0, _moment2.default)().weekday(6).toDate();
	            var start = (0, _moment2.default)().weekday(0).toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Current month',
	          onClick: function onClick(picker) {
	            var lastMonth = (0, _moment2.default)();
	            var end = lastMonth.endOf('month').toDate();
	            var start = lastMonth.startOf('month').toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }, {
	          text: 'Current year',
	          onClick: function onClick(picker) {
	            var end = (0, _moment2.default)().endOf('year').toDate();
	            var start = (0, _moment2.default)().startOf('year').toDate();
	            picker.$emit('pick', [start, end]);
	          }
	        }]
	      }
	    };
	  },
	  methods: {
	    buildParam: function buildParam() {
	      var after = this.filterDateRange[0];
	      var before = this.filterDateRange[1];
	
	      var rUrl = 'start=' + after + '&end=' + before;
	      rUrl = rUrl + '&types=' + this.filterSymptomTypes;
	
	      if (this.selectedOrigin !== 0) {
	        rUrl = rUrl + '&origin=' + this.selectedOrigin;
	      }
	
	      if (this.selectedStatus !== 0) {
	        rUrl = rUrl + '&confirmed=' + (this.selectedStatus === 1 ? 'true' : 'false');
	      }
	
	      if (this.selectedPrecautions !== 0) {
	        rUrl = rUrl + '&precaution=' + this.selectedPrecautions;
	      }
	
	      if (this.selectedOrganisms !== 0) {
	        rUrl = rUrl + '&organism=' + this.selectedOrganisms;
	      }
	
	      if (this.selectedResolved !== 0) {
	        rUrl = rUrl + '&resolved=' + (this.selectedResolved === 1 ? 'true' : 'false');
	      }
	
	      if (this.selectedFamilyNotified !== 0) {
	        rUrl = rUrl + '&familyNotified=' + (this.selectedFamilyNotified === 1 ? 'true' : 'false');
	      }
	
	      if (this.selectedNextOfNotified !== 0) {
	        rUrl = rUrl + '&nextOfNotified=' + (this.selectedNextOfNotified === 1 ? 'true' : 'false');
	      }
	
	      if (this.selectedPhysicianNotified !== 0) {
	        rUrl = rUrl + '&physicianNotified=' + (this.selectedPhysicianNotified === 1 ? 'true' : 'false');
	      }
	
	      if (this.selectedClientType !== 0) {
	        rUrl = rUrl + '&clientType=' + (this.selectedClientType === 1 ? 'Client' : 'Staff');
	      }
	
	      if (this.selectedFirstName !== '') {
	        rUrl = rUrl + '&firstName=' + this.selectedFirstName;
	      }
	
	      if (this.selectedLastName !== '') {
	        rUrl = rUrl + '&lastName=' + this.selectedLastName;
	      }
	
	      return rUrl;
	    },
	    loadCases: function loadCases() {
	      if (!this.loading) {
	        this.loading = true;
	      }
	      var vm = this;
	      var unitId = this.selectedUnit || 0;
	
	      var rUrl = window.CONFIG.api + '/symptomDetail/unit/' + unitId + '/page/' + (vm.symptomDetailPage - 1) + '?size=' + vm.symptomDetailPageSize + '&' + this.buildParam();
	
	      this.$http.get(rUrl).then(function (response) {
	        if (response.body && response.body['content'].length > 0) {
	          var cases = response.body['content'];
	          var callbackCounter = 0;
	
	          vm.symptomDetailPageTotal = response.body['totalPages'];
	          vm.symptomDetailTotal = response.body['totalElements'];
	          cases.forEach(function (c) {
	            if (c.origin == null) {
	              c.origin = 'Not Selected';
	            }
	            c.symptoms.sort(function (a, b) {
	              return a.colorCode > b.colorCode;
	            });
	            vm.loadImage(c, function () {
	              callbackCounter++;
	              if (callbackCounter >= cases.length) {
	                vm.cases = cases;
	              }
	            });
	          });
	        } else {
	          console.log('no content');
	          vm.cases = [];
	        }
	
	        vm.$nextTick(function () {
	          vm.loading = false;
	        });
	      }, function (response) {});
	
	      vm.$watch('graphPeriodFilter', function (val) {
	        if (vm.graphPeriodFilter === 'By Year') {
	          vm.filterPeriods = 'year';
	        } else if (vm.graphPeriodFilter === 'By Quarter') {
	          vm.filterPeriods = 'quarter';
	        } else if (vm.graphPeriodFilter === 'By Month') {
	          vm.filterPeriods = 'month';
	        } else if (vm.graphPeriodFilter === 'By Week') {
	          vm.filterPeriods = 'week';
	        }
	      });
	    },
	    clientName: function clientName(symptomDetail) {
	      var clientData = this.clients[symptomDetail.clientId];
	
	      return this.getClientName(clientData);
	    },
	    getClientName: function getClientName(clientData) {
	      var firstName = clientData.firstName ? clientData.firstName + ' ' : '';
	      var middleName = clientData.middleName ? clientData.middleName + ' ' : '';
	      var lastName = clientData.lastName ? clientData.lastName : '';
	
	      return firstName + middleName + lastName;
	    },
	    loadOrganisms: function loadOrganisms() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/organisms/').then(function (response) {
	        vm.organisms = response.body['_embedded'].organisms;
	        vm.loadPrecautions();
	      }, function (response) {});
	    },
	    loadPrecautions: function loadPrecautions() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/precautions/').then(function (response) {
	        vm.precautions = response.body['_embedded'].precautions;
	        vm.loadTreatments();
	      }, function (response) {});
	    },
	    loadTreatments: function loadTreatments() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/treatments/').then(function (response) {
	        vm.treatments = response.body['_embedded'].treatments;
	        vm.loadCases();
	      }, function (response) {});
	    },
	    loadUnits: function loadUnits() {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/units', {
	        headers: {
	          'Authorization': 'Bearer ' + _auth2.default.getToken()
	        }
	      }).then(function (response) {
	        vm.units = response.body['_embedded'].units;
	        vm.graphConfig = { units: vm.units };
	
	        if (vm.selectedUnit === null && vm.units && vm.units.length > 0) {
	          vm.selectedUnit = vm.units[0].value;
	        }
	
	        vm.units.forEach(function (u) {
	          vm.loadRooms(u);
	        });
	      });
	    },
	    loadRooms: function loadRooms(unit) {
	      var vm = this;
	      this.$http.get(window.CONFIG.api + '/units/' + unit.id + '/rooms').then(function (response) {
	        var rooms = response.body['_embedded'].rooms;
	        rooms.forEach(function (room) {
	          var beds = room.beds;
	          beds.forEach(function (bed) {
	            vm.beds[bed.id] = room.displayText + '-' + bed.displayText;
	          });
	        });
	
	        vm.loadSymptomTypes();
	      }, function (response) {});
	    },
	    loadSymptomTypes: function loadSymptomTypes() {
	      var vm = this;
	
	      this.$http.get(window.CONFIG.api + '/symptoms/classtypes').then(function (response) {
	        vm.symptomTypes = [];
	        var newTypes = response.body;
	        if (newTypes && newTypes.length > 0) {
	          vm.symptomTypes.push({ 'text': 'All Infection Site', 'value': 0 });
	          for (var i = 0; i < newTypes.length - 1; i++) {
	            var s = {};
	            s.text = newTypes[i];
	            s.value = i + 1;
	            vm.symptomTypes.push(s);
	          }
	          vm.filteredSite = vm.symptomTypes[0].value;
	          console.log((0, _stringify2.default)(newTypes, ' ', 2));
	        }
	        vm.loadSymptoms();
	      });
	    },
	    loadSymptoms: function loadSymptoms() {
	      var vm = this;
	
	      this.$http.get(window.CONFIG.api + '/symptoms').then(function (response) {
	        vm.symptoms = response.body['_embedded'].symptoms;
	        vm.loadOrganisms();
	      });
	    },
	    nameFilter: function nameFilter(cases) {
	      var vm = this;
	      return cases.filter(function (detail) {
	        return detail.name.toLowerCase().includes(vm.searchNameInput.toLowerCase());
	      });
	    },
	    reloadPage: function reloadPage(page) {
	      if (this.symptomDetailPage !== page) {
	        this.symptomDetailPage = page;
	        this.loadCases();
	      }
	    },
	    loadImage: function loadImage(detail, callback) {
	      var vm = this;
	      if (this.clients[detail.clientId] || this.clients[detail.clientId] === false) {
	        callback();
	        return;
	      }
	      this.clients[detail.clientId] = false;
	      this.$http.get(window.CONFIG.api + '/clients/' + detail.clientId).then(function (response) {
	        vm.$set(vm.clients, detail.clientId, response.body);
	        vm.$forceUpdate();
	        callback();
	      }, function (response) {
	        callback();
	      });
	    },
	    statusImage: function statusImage(detail) {
	      if (detail.symptomType) {
	        var filename = this.statusImageMap[detail.symptomType];
	        if (!detail.confirmed) {
	          filename = filename + 's';
	        }
	        return '/static/' + filename + '.png';
	      }
	    },
	    tagType: function tagType(type) {
	      if (type.colorCode === '0') {
	        return 'success';
	      } else if (type.colorCode === '1') {
	        return 'primary';
	      } else if (type.colorCode === '2') {
	        return 'warning';
	      } else if (type.colorCode === '3') {
	        return 'danger';
	      }
	      return 'gray';
	    },
	    selectedRow: function selectedRow(row, event, column) {
	      this.selectedCase = row;
	      this.selectedClient = this.clients[row.clientId];
	
	      console.log(this.selectedCase.clientId);
	      var vm = this;
	      vm.$nextTick(function () {
	        vm.caseActiveTab = '1';
	        vm.dialogFormVisible = true;
	        console.log(vm.caseActiveTab);
	      });
	    },
	    dateRangeUpdated: function dateRangeUpdated(value) {
	      if (!value) {
	        var end = new Date();
	        var start = new Date();
	        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
	
	        this.filterDateRange = [start, end];
	      }
	
	      this.loadCases();
	    },
	    unitUpdated: function unitUpdated(value) {
	      this.loadCases();
	    },
	    originUpdated: function originUpdated(value) {
	      if (value === 0) {
	        this.filterOrigin = null;
	      } else {
	        this.filterOrigin = value;
	      }
	      console.log('originUpdated:' + value);
	      this.loadCases();
	    },
	    precautionUpdated: function precautionUpdated(value) {
	      console.log('precautionUpdated: ', +value);
	      this.loadCases();
	    },
	    organismsUpdated: function organismsUpdated(value) {
	      this.loadCases();
	    },
	    resolvedUpdated: function resolvedUpdated(value) {
	      this.loadCases();
	    },
	    confirmStatusUpdated: function confirmStatusUpdated(value) {
	      console.log('confirmStatusUpdated:' + value);
	      if (value === 0) {
	        this.filterConfirmStatus = null;
	      } else {
	        this.filterConfirmStatus = value === 1 ? 'true' : 'false';
	      }
	      this.loadCases();
	    },
	    symptomTypeUpdated: function symptomTypeUpdated(value) {
	      var vm = this;
	      var sypmtomTypeFilter = [];
	      if (this.symptomTypes) {
	        this.symptomTypes.forEach(function (s, i) {
	          if ((vm.filteredSite === 0 || vm.filteredSite === s.value) && i !== 0) {
	            sypmtomTypeFilter.push(s.text);
	          }
	        });
	      }
	
	      this.filterSymptomTypes = sypmtomTypeFilter;
	      this.loadCases();
	    },
	    organismById: function organismById(organId) {
	      var organName = 'Not Selected';
	      if (organId === 0) {
	        return organName;
	      }
	
	      this.organisms.forEach(function (o) {
	        if (o.id === organId) {
	          organName = o.name;
	        }
	      });
	
	      return organName;
	    },
	    treatmentById: function treatmentById(treatmentId) {
	      var name = 'Not Selected';
	      if (treatmentId === 0) {
	        return name;
	      }
	
	      this.treatments.forEach(function (t) {
	        if (t.id === treatmentId) {
	          name = t.displayText;
	        }
	      });
	
	      return name;
	    },
	    unitById: function unitById(unitId) {
	      var unitName = '';
	      this.units.forEach(function (u) {
	        if (u.id === unitId) {
	          unitName = u.displayText;
	        }
	      });
	
	      return unitName;
	    },
	    originById: function originById(originId) {
	      var originName = 'Not Selected';
	      this.origins.forEach(function (o) {
	        if (o.value === originId && o.value !== 0) {
	          originName = o.label;
	        }
	      });
	      return originName;
	    },
	    unitByName: function unitByName(unitName) {
	      var unit = null;
	      this.units.forEach(function (u) {
	        if (u.displayText === unitName) {
	          unit = u;
	        }
	      });
	
	      return unit;
	    },
	    precautionById: function precautionById(precautionId) {
	      var name = '';
	      this.precautions.forEach(function (p) {
	        if (p.id === precautionId) {
	          name = p.displayText;
	        }
	      });
	
	      return name;
	    },
	    photosUrl: function photosUrl(clientId) {
	      if (this.clients[clientId].photo) {
	        return '/static/' + this.clients[clientId].photo + '.png';
	      }
	
	      return '/static/user.png';
	    },
	    saveSymtomDetail: function saveSymtomDetail(symptomDetail) {
	      var vm = this;
	      var caseDetail = JSON.parse((0, _stringify2.default)(symptomDetail));
	      delete caseDetail.id;
	      caseDetail.symptoms.forEach(function (s) {
	        delete s.id;
	      });
	
	      var jsonData = (0, _stringify2.default)(caseDetail);
	      this.$http.put(window.CONFIG.api + '/symptomDetails/' + symptomDetail.id, jsonData).then(function (response) {
	        vm.dialogFormVisible = false;
	        vm.selectedCase = null;
	        vm.loadCases();
	      }, function (response) {
	        console.log(response);
	        console.log('err');
	      });
	    },
	    reverse: function reverse(array) {
	      return array.slice().reverse();
	    },
	    isStaff: function isStaff(client) {
	      return client.clientType === 'Staff';
	    },
	    exportExcel: function exportExcel() {
	      var loadingInstance = _elementUi.Loading.service({ fullscreen: true });
	      console.log('exportExcel clicked');
	      var unitId = this.selectedUnit;
	      var rUrl = window.CONFIG.api + '/symptomDetail/unit/' + unitId + '/export/excel/' + '?' + this.buildParam();
	
	      this.$http.get(rUrl).then(function (response) {
	        console.log((0, _stringify2.default)(response, ' ', 2));
	        var headers = response.headers.map;
	        var blob = new window.Blob([response.data], { type: headers['content-type'] });
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'report.xls';
	        link.click();
	        loadingInstance.close();
	      });
	    },
	    createNewCase: function createNewCase() {
	      this.newCase = {
	        client: null,
	        symptoms: []
	      };
	      this.newCaseDialogFormVisible = true;
	    },
	    addSymptoms: function addSymptoms(userId, symptoms) {
	      var _this = this;
	
	      var vm = this;
	      var symptomList = [];
	      this.symptoms.forEach(function (d) {
	        symptoms.forEach(function (s) {
	          if (d.id === s) {
	            symptomList.push(d);
	          }
	        });
	      });
	
	      this.newCase = {
	        client: null,
	        symptoms: []
	      };
	
	      var jsonData = (0, _stringify2.default)(symptomList);
	      console.log(jsonData);
	      this.$http.post(window.CONFIG.api + '/client/symptom/add/' + userId, jsonData).then(function (response) {
	        console.log((0, _stringify2.default)(response, 2, ' '));
	        vm.loadCases();
	        _this.newCaseDialogFormVisible = false;
	      }, function (response) {});
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    var end = (0, _moment2.default)().endOf('year').toDate();
	    var start = (0, _moment2.default)().startOf('year').toDate();
	    this.filterDateRange = [start, end];
	
	    var vm = this;
	
	    this.$http.get(window.CONFIG.authHost + '/api/account/me').then(function (response) {
	      console.log((0, _stringify2.default)(response, ' ', 2));
	    });
	
	    this.$http.get(window.CONFIG.api + '/clients').then(function (response) {
	      if (response.body) {
	        vm.clientList = response.body['_embedded'].clients;
	      } else {
	        vm.clientList = [];
	      }
	
	      _this2.loadUnits();
	    }, function (response) {});
	  }
	};

/***/ },
/* 176 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'surveillance-biology',
	  props: ['organisms'],
	  data: function data() {
	    return {
	      biologyInfo: [{
	        label: 'Primary'
	      }, {
	        label: 'Secondary'
	      }, {
	        label: 'Primary'
	      }, {
	        label: 'Quaternary'
	      }]
	    };
	  }
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'surveillance-case-detail',
	  props: ['caseData', 'clientData', 'origins', 'organisms', 'treatments'],
	  data: function data() {
	    return {
	      statusImageMap: {
	        'GI': 'bug2',
	        'UTI': 'bug3',
	        'Respiratory': 'bug1'
	      }
	    };
	  },
	  watch: {
	    clientData: function clientData(value) {
	      console.log('New ClientData: ' + (0, _stringify2.default)(value, ' ', 2));
	    }
	  },
	  methods: {
	    originById: function originById(originId) {
	      var originName = 'Not Selected';
	      this.origins.forEach(function (o) {
	        if (o.value === originId && o.value !== 0) {
	          originName = o.label;
	        }
	      });
	      return originName;
	    },
	    clientName: function clientName() {
	      var firstName = this.clientData.firstName ? this.clientData.firstName + ' ' : '';
	      var middleName = this.clientData.middleName ? this.clientData.middleName + ' ' : '';
	      var lastName = this.clientData.lastName ? this.clientData.lastName : '';
	
	      return firstName + middleName + lastName;
	    },
	    userPhoto: function userPhoto() {
	      return '/static/' + (this.clientData.photo ? this.clientData.photo : 'user') + '.png';
	    },
	    tagType: function tagType(type) {
	      if (type.colorCode === '0') {
	        return 'success';
	      } else if (type.colorCode === '1') {
	        return 'primary';
	      } else if (type.colorCode === '2') {
	        return 'warning';
	      } else if (type.colorCode === '3') {
	        return 'danger';
	      }
	      return 'gray';
	    },
	    statusImage: function statusImage(detail) {
	      if (detail.symptomType) {
	        var filename = this.statusImageMap[detail.symptomType];
	        if (!detail.confirmed) {
	          filename = filename + 's';
	        }
	        return '/static/' + filename + '.png';
	      }
	    }
	  }
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _elementUi = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'surveillance-communication',
	  props: ['notes', 'caseData'],
	  data: function data() {
	    return {
	      newNotes: [],
	      allNotes: []
	    };
	  },
	  watch: {
	    notes: function notes(value) {
	      this.newNotes = [];
	      this.allNotes = value;
	      console.log((0, _stringify2.default)(value, ' ', 2));
	    },
	    newNotes: function newNotes(value) {
	      this.allNotes = value.concat(this.notes);
	      console.log((0, _stringify2.default)(this.allNotes, ' ', 2));
	    }
	  },
	  methods: {
	    addNewNote: function addNewNote() {
	      var now = new Date();
	      var newNote = {
	        created: now.getTime(),
	        content: '',
	        isNew: true
	      };
	      this.newNotes.splice(0, 0, newNote);
	    },
	    cancelAction: function cancelAction(index, data) {
	      console.log((0, _stringify2.default)(data, ' ', 2));
	      this.newNotes.splice(index, 1);
	    },
	    saveAction: function saveAction(index, data) {
	      var vm = this;
	      var loadingInstance = _elementUi.Loading.service({ fullscreen: true });
	      var newNote = {
	        created: data.created,
	        content: data.content,
	        refId: this.caseData.id
	      };
	      console.log((0, _stringify2.default)(newNote));
	      console.log((0, _stringify2.default)(this.caseData));
	
	      this.$http.post(window.CONFIG.api + '/symptomDetail/new/note', newNote).then(function (response) {
	        console.log((0, _stringify2.default)(response, 2, ' '));
	        if (response.status === 200) {
	          vm.caseData.notes.splice(0, 0, newNote);
	          vm.newNotes.splice(index, 1);
	        }
	        loadingInstance.close();
	      }, function (response) {});
	    }
	  },
	  mounted: function mounted() {
	    console.log('mounted!');
	    this.allNotes = this.notes;
	  }
	};

/***/ },
/* 179 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'surveillance-device',
	  data: function data() {
	    return {
	      deviceInfo: [{
	        label: 'Catheter'
	      }, {
	        label: 'Ventilator'
	      }, {
	        label: 'Central Line'
	      }, {
	        label: 'IV Used'
	      }]
	    };
	  }
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _elementUi = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'surveillance-personal-info',
	  props: ['clientData'],
	  data: function data() {
	    return {
	      newNotes: [],
	      allNotes: []
	    };
	  },
	  watch: {
	    clientData: function clientData(value) {
	      this.newNotes = [];
	      this.allNotes = value.notes;
	    },
	    newNotes: function newNotes(value) {
	      this.allNotes = value.concat(this.clientData.notes);
	      console.log((0, _stringify2.default)(this.allNotes, ' ', 2));
	    }
	  },
	  methods: {
	    symptomDetail: function symptomDetail(symptomType) {
	      return symptomType + ' detail text goes here';
	    },
	    isStaff: function isStaff() {
	      return this.clientData.clientType === 'Staff';
	    },
	
	    addNewNote: function addNewNote() {
	      var now = new Date();
	      var newNote = {
	        created: now.getTime(),
	        content: '',
	        isNew: true
	      };
	      this.newNotes.splice(0, 0, newNote);
	    },
	    cancelAction: function cancelAction(index, data) {
	      console.log((0, _stringify2.default)(data, ' ', 2));
	      this.newNotes.splice(index, 1);
	    },
	    saveAction: function saveAction(index, data) {
	      var vm = this;
	      var loadingInstance = _elementUi.Loading.service({ fullscreen: true });
	      var newNote = {
	        created: data.created,
	        content: data.content,
	        refId: this.clientData.id
	      };
	      console.log((0, _stringify2.default)(newNote));
	      console.log((0, _stringify2.default)(this.caseData));
	
	      this.$http.post(window.CONFIG.api + '/client/new/note', newNote).then(function (response) {
	        console.log((0, _stringify2.default)(response, 2, ' '));
	        if (response.status === 200) {
	          vm.clientData.notes.splice(0, 0, newNote);
	          vm.newNotes.splice(index, 1);
	        }
	        loadingInstance.close();
	      }, function (response) {});
	    }
	  },
	  mounted: function mounted() {
	    console.log('mounted!');
	    this.allNotes = this.clientData.notes;
	  }
	};

/***/ },
/* 181 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'surveillance-precaution',
	  props: ['caseData', 'clientData', 'precautions'],
	  data: function data() {
	    return {};
	  },
	  methods: {
	    precautionById: function precautionById(precautionId) {
	      var name = '';
	      this.precautions.forEach(function (p) {
	        if (p.id === precautionId) {
	          name = p.displayText;
	        }
	      });
	
	      return name;
	    }
	  }
	};

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'surveillance-symptoms',
	  props: ['caseData'],
	  data: function data() {
	    return {
	      biologyInfo: [{
	        label: 'Primary'
	      }, {
	        label: 'Secondary'
	      }, {
	        label: 'Primary'
	      }, {
	        label: 'Quaternary'
	      }]
	    };
	  },
	  methods: {
	    symptomDetail: function symptomDetail(symptomType) {
	      return symptomType + ' detail text goes here';
	    }
	  }
	};

/***/ },
/* 183 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'surveillance-treatment',
	  props: ['caseData'],
	  data: function data() {
	    return {};
	  },
	  methods: {
	    symptomDetail: function symptomDetail(symptomType) {
	      return symptomType + ' detail text goes here';
	    }
	  }
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'symptom-case-detail',
	  props: ['caseData', 'clientData', 'origins', 'organisms', 'treatments'],
	  data: function data() {
	    return {
	      statusImageMap: {
	        'GI': 'bug2',
	        'UTI': 'bug3',
	        'Respiratory': 'bug1'
	      }
	    };
	  },
	  methods: {
	    originById: function originById(originId) {
	      console.log(this.selectedCase.origin);
	      console.log((0, _stringify2.default)(this.origins, ' ', 2));
	      var originName = 'Not Selected';
	      this.origins.forEach(function (o) {
	        if (o.value === originId && o.value !== 0) {
	          originName = o.label;
	        }
	      });
	      return originName;
	    },
	    photoUrl: function photoUrl() {
	      return '/static/' + this.clientData.photo + '.png';
	    },
	    tagType: function tagType(type) {
	      if (type.colorCode === '0') {
	        return 'success';
	      } else if (type.colorCode === '1') {
	        return 'primary';
	      } else if (type.colorCode === '2') {
	        return 'warning';
	      } else if (type.colorCode === '3') {
	        return 'danger';
	      }
	      return 'gray';
	    },
	    statusImage: function statusImage(detail) {
	      if (detail.symptomType) {
	        var filename = this.statusImageMap[detail.symptomType];
	        if (!detail.confirmed) {
	          filename = filename + 's';
	        }
	        return '/static/' + filename + '.png';
	      }
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ },
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 207 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 208 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 209 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 210 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 211 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 212 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 213 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 214 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 215 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 216 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 217 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 218 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 219 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 220 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 221 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 222 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 223 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 224 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 225 */,
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 29,
		"./af.js": 29,
		"./ar": 35,
		"./ar-dz": 30,
		"./ar-dz.js": 30,
		"./ar-ly": 31,
		"./ar-ly.js": 31,
		"./ar-ma": 32,
		"./ar-ma.js": 32,
		"./ar-sa": 33,
		"./ar-sa.js": 33,
		"./ar-tn": 34,
		"./ar-tn.js": 34,
		"./ar.js": 35,
		"./az": 36,
		"./az.js": 36,
		"./be": 37,
		"./be.js": 37,
		"./bg": 38,
		"./bg.js": 38,
		"./bn": 39,
		"./bn.js": 39,
		"./bo": 40,
		"./bo.js": 40,
		"./br": 41,
		"./br.js": 41,
		"./bs": 42,
		"./bs.js": 42,
		"./ca": 43,
		"./ca.js": 43,
		"./cs": 44,
		"./cs.js": 44,
		"./cv": 45,
		"./cv.js": 45,
		"./cy": 46,
		"./cy.js": 46,
		"./da": 47,
		"./da.js": 47,
		"./de": 49,
		"./de-at": 48,
		"./de-at.js": 48,
		"./de.js": 49,
		"./dv": 50,
		"./dv.js": 50,
		"./el": 51,
		"./el.js": 51,
		"./en-au": 52,
		"./en-au.js": 52,
		"./en-ca": 53,
		"./en-ca.js": 53,
		"./en-gb": 54,
		"./en-gb.js": 54,
		"./en-ie": 55,
		"./en-ie.js": 55,
		"./en-nz": 56,
		"./en-nz.js": 56,
		"./eo": 57,
		"./eo.js": 57,
		"./es": 59,
		"./es-do": 58,
		"./es-do.js": 58,
		"./es.js": 59,
		"./et": 60,
		"./et.js": 60,
		"./eu": 61,
		"./eu.js": 61,
		"./fa": 62,
		"./fa.js": 62,
		"./fi": 63,
		"./fi.js": 63,
		"./fo": 64,
		"./fo.js": 64,
		"./fr": 67,
		"./fr-ca": 65,
		"./fr-ca.js": 65,
		"./fr-ch": 66,
		"./fr-ch.js": 66,
		"./fr.js": 67,
		"./fy": 68,
		"./fy.js": 68,
		"./gd": 69,
		"./gd.js": 69,
		"./gl": 70,
		"./gl.js": 70,
		"./he": 71,
		"./he.js": 71,
		"./hi": 72,
		"./hi.js": 72,
		"./hr": 73,
		"./hr.js": 73,
		"./hu": 74,
		"./hu.js": 74,
		"./hy-am": 75,
		"./hy-am.js": 75,
		"./id": 76,
		"./id.js": 76,
		"./is": 77,
		"./is.js": 77,
		"./it": 78,
		"./it.js": 78,
		"./ja": 79,
		"./ja.js": 79,
		"./jv": 80,
		"./jv.js": 80,
		"./ka": 81,
		"./ka.js": 81,
		"./kk": 82,
		"./kk.js": 82,
		"./km": 83,
		"./km.js": 83,
		"./ko": 84,
		"./ko.js": 84,
		"./ky": 85,
		"./ky.js": 85,
		"./lb": 86,
		"./lb.js": 86,
		"./lo": 87,
		"./lo.js": 87,
		"./lt": 88,
		"./lt.js": 88,
		"./lv": 89,
		"./lv.js": 89,
		"./me": 90,
		"./me.js": 90,
		"./mi": 91,
		"./mi.js": 91,
		"./mk": 92,
		"./mk.js": 92,
		"./ml": 93,
		"./ml.js": 93,
		"./mr": 94,
		"./mr.js": 94,
		"./ms": 96,
		"./ms-my": 95,
		"./ms-my.js": 95,
		"./ms.js": 96,
		"./my": 97,
		"./my.js": 97,
		"./nb": 98,
		"./nb.js": 98,
		"./ne": 99,
		"./ne.js": 99,
		"./nl": 101,
		"./nl-be": 100,
		"./nl-be.js": 100,
		"./nl.js": 101,
		"./nn": 102,
		"./nn.js": 102,
		"./pa-in": 103,
		"./pa-in.js": 103,
		"./pl": 104,
		"./pl.js": 104,
		"./pt": 106,
		"./pt-br": 105,
		"./pt-br.js": 105,
		"./pt.js": 106,
		"./ro": 107,
		"./ro.js": 107,
		"./ru": 108,
		"./ru.js": 108,
		"./se": 109,
		"./se.js": 109,
		"./si": 110,
		"./si.js": 110,
		"./sk": 111,
		"./sk.js": 111,
		"./sl": 112,
		"./sl.js": 112,
		"./sq": 113,
		"./sq.js": 113,
		"./sr": 115,
		"./sr-cyrl": 114,
		"./sr-cyrl.js": 114,
		"./sr.js": 115,
		"./ss": 116,
		"./ss.js": 116,
		"./sv": 117,
		"./sv.js": 117,
		"./sw": 118,
		"./sw.js": 118,
		"./ta": 119,
		"./ta.js": 119,
		"./te": 120,
		"./te.js": 120,
		"./tet": 121,
		"./tet.js": 121,
		"./th": 122,
		"./th.js": 122,
		"./tl-ph": 123,
		"./tl-ph.js": 123,
		"./tlh": 124,
		"./tlh.js": 124,
		"./tr": 125,
		"./tr.js": 125,
		"./tzl": 126,
		"./tzl.js": 126,
		"./tzm": 128,
		"./tzm-latn": 127,
		"./tzm-latn.js": 127,
		"./tzm.js": 128,
		"./uk": 129,
		"./uk.js": 129,
		"./uz": 130,
		"./uz.js": 130,
		"./vi": 131,
		"./vi.js": 131,
		"./x-pseudo": 132,
		"./x-pseudo.js": 132,
		"./yo": 133,
		"./yo.js": 133,
		"./zh-cn": 134,
		"./zh-cn.js": 134,
		"./zh-hk": 135,
		"./zh-hk.js": 135,
		"./zh-tw": 136,
		"./zh-tw.js": 136
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 226;


/***/ },
/* 227 */,
/* 228 */,
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(214)
	__webpack_require__(215)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(168),
	  /* template */
	  __webpack_require__(246),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(220)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(169),
	  /* template */
	  __webpack_require__(251),
	  /* scopeId */
	  "data-v-a043216a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(212)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(170),
	  /* template */
	  __webpack_require__(244),
	  /* scopeId */
	  "data-v-39ccaf17",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(221)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(171),
	  /* template */
	  __webpack_require__(252),
	  /* scopeId */
	  "data-v-c87e052c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(209)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(172),
	  /* template */
	  __webpack_require__(241),
	  /* scopeId */
	  "data-v-1ed7eeec",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(206)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(173),
	  /* template */
	  __webpack_require__(238),
	  /* scopeId */
	  "data-v-14ab1646",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(216)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(174),
	  /* template */
	  __webpack_require__(247),
	  /* scopeId */
	  "data-v-6a395574",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(207)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(175),
	  /* template */
	  __webpack_require__(239),
	  /* scopeId */
	  "data-v-1814cce6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(218)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(184),
	  /* template */
	  __webpack_require__(249),
	  /* scopeId */
	  "data-v-719db52d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overview"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 100
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 16,
	      "offset": 4
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchNameInput),
	      expression: "searchNameInput"
	    }],
	    attrs: {
	      "placeholder": "Search by Name"
	    },
	    domProps: {
	      "value": (_vm.searchNameInput)
	    },
	    on: {
	      "input": function($event) {
	        _vm.searchNameInput = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, _vm._l((_vm.nameFilter(_vm.cases)), function(o, index) {
	    return _c('el-col', {
	      attrs: {
	        "span": 6,
	        "offset": index % 3 == 0 ? 3 : (index % 3 == 1 ? 0 : 0)
	      }
	    }, [_c('el-card', [_c('div', {
	      staticStyle: {
	        "padding": "14px"
	      }
	    }, [_c('div', {
	      staticClass: "clearfix",
	      slot: "header"
	    }, [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('span', [_vm._v("Name: ")])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 16
	      }
	    }, [_vm._v(_vm._s(o.name))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('span', [_vm._v("Infection Site: ")])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 16
	      }
	    }, [_vm._v(_vm._s(o.symptomType) + "\n                    "), (o.symptomType === 'GI') ? _c('span', {
	      staticClass: "color-code-label-0"
	    }) : (o.symptomType === 'UTI') ? _c('span', {
	      staticClass: "color-code-label-3"
	    }) : _c('span', {
	      staticClass: "color-code-label-1"
	    })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_vm._v("Onset Date:")]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 16
	      }
	    }, [_c('el-date-picker', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (o.onSetDate),
	        expression: "o.onSetDate"
	      }],
	      attrs: {
	        "type": "date",
	        "readonly": "",
	        "editable": "",
	        "clearable": ""
	      },
	      domProps: {
	        "value": (o.onSetDate)
	      },
	      on: {
	        "input": function($event) {
	          o.onSetDate = $event
	        }
	      }
	    })], 1)], 1)], 1)])], 1)
	  }))], 1)
	},staticRenderFns: []}

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance"
	  }, [_c('el-popover', {
	    ref: "filterpopover",
	    attrs: {
	      "placement": "bottom-end",
	      "width": "300",
	      "trigger": "click"
	    }
	  }, [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("Precautions:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.precaution),
	      expression: "allFilters.precaution"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.precaution)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.precaution = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("Organisms:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.organism),
	      expression: "allFilters.organism"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.organism)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.organism = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("Resolutions:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.resolution),
	      expression: "allFilters.resolution"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.resolution)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.resolution = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("Family Notified:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.familyNotified),
	      expression: "allFilters.familyNotified"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.familyNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.familyNotified = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("Next Of Kin Notified:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.nextOfKinNotified),
	      expression: "allFilters.nextOfKinNotified"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.nextOfKinNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.nextOfKinNotified = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("Physician Notified:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.physicianNotified),
	      expression: "allFilters.physicianNotified"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.physicianNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.physicianNotified = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("Staff:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.staffOrRes),
	      expression: "allFilters.staffOrRes"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.staffOrRes)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.staffOrRes = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("First Name:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.firstName),
	      expression: "allFilters.firstName"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.firstName)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.firstName = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_vm._v("Last Name:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allFilters.lastName),
	      expression: "allFilters.lastName"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.allFilters.lastName)
	    },
	    on: {
	      "input": function($event) {
	        _vm.allFilters.lastName = $event
	      }
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "filter"
	  }, [_c('div', {
	    staticClass: "section-header"
	  }, [_c('el-row', [_c('span', [_vm._v("Surveillance")]), _vm._v(" "), _c('div', {
	    staticClass: "case-filter"
	  }, [_c('el-button', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:filterpopover",
	      arg: "filterpopover"
	    }],
	    attrs: {
	      "size": "mini"
	    }
	  }, [_vm._v("Add Filters")])], 1)])], 1), _vm._v(" "), _c('el-row', {
	    staticClass: "filter-section"
	  }, [_c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Date Range:")]), _vm._v(" "), _c('el-date-picker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filterDateRange),
	      expression: "filterDateRange"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "label": "Date Range",
	      "type": "daterange",
	      "placeholder": "Date Range",
	      "format": "dd-MM-yyyy",
	      "range-separator": " ~ ",
	      "picker-options": _vm.pickerOptions,
	      "clearable": false,
	      "small": ""
	    },
	    domProps: {
	      "value": (_vm.filterDateRange)
	    },
	    on: {
	      "change": _vm.dateRangeUpdated,
	      "input": function($event) {
	        _vm.filterDateRange = $event
	      }
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_vm._v("Http://")])], 2)], 1), _vm._v(" "), _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Unit:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedUnit),
	      expression: "selectedUnit"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Unit"
	    },
	    domProps: {
	      "value": (_vm.selectedUnit)
	    },
	    on: {
	      "change": _vm.unitUpdated,
	      "input": function($event) {
	        _vm.selectedUnit = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All Units",
	      "value": 0
	    }
	  }), _vm._v(" "), _vm._l((_vm.units), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.displayText,
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.displayText))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "float": "right",
	        "color": "#8492a6",
	        "font-size": "13px"
	      }
	    }, [_vm._v(_vm._s(item.value))])])
	  })], 2)], 1), _vm._v(" "), _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Infection Site:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filteredSite),
	      expression: "filteredSite"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Select Infection Site"
	    },
	    domProps: {
	      "value": (_vm.filteredSite)
	    },
	    on: {
	      "change": _vm.symptomTypeUpdated,
	      "input": function($event) {
	        _vm.filteredSite = $event
	      }
	    }
	  }, _vm._l((_vm.symptomTypes), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.text,
	        "value": item.value
	      }
	    })
	  }))], 1), _vm._v(" "), (_vm.allFilters.origin) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Origin:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedOrigin),
	      expression: "selectedOrigin"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Origin"
	    },
	    domProps: {
	      "value": (_vm.selectedOrigin)
	    },
	    on: {
	      "change": _vm.originUpdated,
	      "input": function($event) {
	        _vm.selectedOrigin = $event
	      }
	    }
	  }, _vm._l((_vm.origins), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }))], 1) : _vm._e(), _vm._v(" "), _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedStatus),
	      expression: "selectedStatus"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Status"
	    },
	    domProps: {
	      "value": (_vm.selectedStatus)
	    },
	    on: {
	      "change": _vm.confirmStatusUpdated,
	      "input": function($event) {
	        _vm.selectedStatus = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All",
	      "value": 0
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Confirmed",
	      "value": 1
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Suspected",
	      "value": 2
	    }
	  })], 1)], 1), _vm._v(" "), (_vm.allFilters.precaution) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Precautions:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedPrecautions),
	      expression: "selectedPrecautions"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Precautions"
	    },
	    domProps: {
	      "value": (_vm.selectedPrecautions)
	    },
	    on: {
	      "change": _vm.precautionUpdated,
	      "input": function($event) {
	        _vm.selectedPrecautions = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All Precautions",
	      "value": 0
	    }
	  }), _vm._v(" "), _vm._l((_vm.precautions), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.displayText,
	        "value": item.id
	      }
	    })
	  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.organism) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Organisms:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedOrganisms),
	      expression: "selectedOrganisms"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Not Selected"
	    },
	    domProps: {
	      "value": (_vm.selectedOrganisms)
	    },
	    on: {
	      "change": _vm.organismsUpdated,
	      "input": function($event) {
	        _vm.selectedOrganisms = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Not Selected",
	      "value": 0
	    }
	  }), _vm._v(" "), _vm._l((_vm.organisms), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "float": "right",
	        "color": "#8492a6",
	        "font-size": "13px"
	      }
	    }, [_vm._v(_vm._s(item.value))])])
	  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.resolution) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Resolution:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedResolved),
	      expression: "selectedResolved"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Resolution"
	    },
	    domProps: {
	      "value": (_vm.selectedResolved)
	    },
	    on: {
	      "change": _vm.resolvedUpdated,
	      "input": function($event) {
	        _vm.selectedResolved = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All",
	      "value": 0
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Resolved",
	      "value": 1
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Not Resolved",
	      "value": 2
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.familyNotified) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Family Notified:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedFamilyNotified),
	      expression: "selectedFamilyNotified"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Family Notified"
	    },
	    domProps: {
	      "value": (_vm.selectedFamilyNotified)
	    },
	    on: {
	      "change": _vm.resolvedUpdated,
	      "input": function($event) {
	        _vm.selectedFamilyNotified = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All",
	      "value": 0
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Notified",
	      "value": 1
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Not Notified",
	      "value": 2
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.nextOfKinNotified) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Next of Kin Notified:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedNextOfNotified),
	      expression: "selectedNextOfNotified"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Next of Kin Notified"
	    },
	    domProps: {
	      "value": (_vm.selectedNextOfNotified)
	    },
	    on: {
	      "change": _vm.resolvedUpdated,
	      "input": function($event) {
	        _vm.selectedNextOfNotified = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All",
	      "value": 0
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Notified",
	      "value": 1
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Not Notified",
	      "value": 2
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.physicianNotified) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Physician Notified:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedPhysicianNotified),
	      expression: "selectedPhysicianNotified"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Physician Notified"
	    },
	    domProps: {
	      "value": (_vm.selectedPhysicianNotified)
	    },
	    on: {
	      "change": _vm.resolvedUpdated,
	      "input": function($event) {
	        _vm.selectedPhysicianNotified = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All",
	      "value": 0
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Notified",
	      "value": 1
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Not Notified",
	      "value": 2
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.staffOrRes) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Client Type:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedClientType),
	      expression: "selectedClientType"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Client Type"
	    },
	    domProps: {
	      "value": (_vm.selectedClientType)
	    },
	    on: {
	      "change": _vm.resolvedUpdated,
	      "input": function($event) {
	        _vm.selectedClientType = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All",
	      "value": 0
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Resident",
	      "value": 1
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Staff",
	      "value": 2
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.firstName) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("First Name:")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedFirstName),
	      expression: "selectedFirstName"
	    }],
	    attrs: {
	      "placeholder": "First Name",
	      "icon": "search",
	      "on-icon-click": _vm.resolvedUpdated
	    },
	    domProps: {
	      "value": (_vm.selectedFirstName)
	    },
	    on: {
	      "input": function($event) {
	        _vm.selectedFirstName = $event
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.allFilters.lastName) ? _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Last Name:")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedLastName),
	      expression: "selectedLastName"
	    }],
	    attrs: {
	      "placeholder": "Last Name",
	      "icon": "search",
	      "on-icon-click": _vm.resolvedUpdated
	    },
	    domProps: {
	      "value": (_vm.selectedLastName)
	    },
	    on: {
	      "input": function($event) {
	        _vm.selectedLastName = $event
	      }
	    }
	  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCaseDialogFormVisible),
	      expression: "newCaseDialogFormVisible"
	    }],
	    attrs: {
	      "title": "New Case"
	    },
	    domProps: {
	      "value": (_vm.newCaseDialogFormVisible)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newCaseDialogFormVisible = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "new-case-dialog"
	  }, [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Residents:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCase.client),
	      expression: "newCase.client"
	    }],
	    attrs: {
	      "filterable": "",
	      "placeholder": "Not Selected"
	    },
	    domProps: {
	      "value": (_vm.newCase.client)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newCase.client = $event
	      }
	    }
	  }, _vm._l((_vm.clientList), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": _vm.getClientName(item),
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(_vm.getClientName(item)))])])
	  }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Symptoms:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCase.symptoms),
	      expression: "newCase.symptoms"
	    }],
	    attrs: {
	      "filterable": "",
	      "multiple": "",
	      "placeholder": "Not Selected"
	    },
	    domProps: {
	      "value": (_vm.newCase.symptoms)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newCase.symptoms = $event
	      }
	    }
	  }, _vm._l((_vm.symptoms), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.displayText,
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.displayText))])])
	  }))], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.addSymptoms(_vm.newCase.client, _vm.newCase.symptoms)
	      }
	    }
	  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.newCaseDialogFormVisible = false;
	        this.newCase = {
	          client: null,
	          symptoms: []
	        }
	      }
	    }
	  }, [_vm._v("Close")])], 1)], 1)]), _vm._v(" "), (_vm.selectedCase) ? _c('el-dialog', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dialogFormVisible),
	      expression: "dialogFormVisible"
	    }],
	    attrs: {
	      "title": _vm.clientName(_vm.selectedCase),
	      "size": "large"
	    },
	    domProps: {
	      "value": (_vm.dialogFormVisible)
	    },
	    on: {
	      "input": function($event) {
	        _vm.dialogFormVisible = $event
	      }
	    }
	  }, [_c('el-tabs', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseActiveTab),
	      expression: "caseActiveTab"
	    }],
	    attrs: {
	      "type": "card"
	    },
	    domProps: {
	      "value": (_vm.caseActiveTab)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseActiveTab = $event
	      }
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": "Case Detail",
	      "name": "1"
	    }
	  }, [_c('surveillance-case-detail', {
	    attrs: {
	      "caseData": _vm.selectedCase,
	      "clientData": _vm.clients[_vm.selectedCase.clientId],
	      "origins": _vm.origins,
	      "organisms": _vm.organisms,
	      "treatments": _vm.treatments
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.saveSymtomDetail(_vm.selectedCase)
	      }
	    }
	  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogFormVisible = false;
	        this.selectedCase = null
	      }
	    }
	  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Communication",
	      "name": "2"
	    }
	  }, [_c('surveillance-communication', {
	    attrs: {
	      "caseData": _vm.selectedCase,
	      "clientData": _vm.clients[_vm.selectedCase.clientId],
	      "notes": _vm.selectedCase.notes
	    }
	  })], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Signs and Symptoms",
	      "name": "5"
	    }
	  }, [_c('surveillance-symptoms', {
	    attrs: {
	      "caseData": _vm.selectedCase
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.saveSymtomDetail(_vm.selectedCase)
	      }
	    }
	  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogFormVisible = false;
	        this.selectedCase = null
	      }
	    }
	  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Treatment",
	      "name": "6"
	    }
	  }, [_c('surveillance-treatment', {
	    attrs: {
	      "caseData": _vm.selectedCase
	    }
	  })], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Individual",
	      "name": "7"
	    }
	  }, [_c('surveillance-personal-info', {
	    attrs: {
	      "clientData": _vm.clients[_vm.selectedCase.clientId]
	    }
	  })], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Precaution",
	      "name": "8"
	    }
	  }, [_c('surveillance-precaution', {
	    attrs: {
	      "caseData": _vm.selectedCase,
	      "precautions": _vm.precautions,
	      "clientData": _vm.clients[_vm.selectedCase.clientId]
	    }
	  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "section-header"
	  }, [_c('el-row', [_c('span', [_vm._v("Case Detail - Total: " + _vm._s(_vm.symptomDetailTotal))]), _vm._v(" "), _c('div', {
	    staticClass: "case-filter"
	  }, [_c('el-button', {
	    staticClass: "case-export-button",
	    attrs: {
	      "plain": true,
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": function($event) {
	        _vm.createNewCase()
	      }
	    }
	  }, [_vm._v(" + New Case")]), _vm._v(" "), _c('el-button', {
	    staticClass: "case-export-button",
	    attrs: {
	      "plain": true,
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": function($event) {
	        _vm.exportExcel()
	      }
	    }
	  }, [_vm._v("Export Data")]), _vm._v(" "), _c('el-pagination', {
	    attrs: {
	      "small": "",
	      "layout": "prev, pager, next",
	      "current-page": _vm.symptomDetailPage,
	      "page-count": _vm.symptomDetailPageTotal
	    },
	    on: {
	      "current-change": _vm.reloadPage
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.cases,
	      "default-sort": {
	        prop: 'onSetDate',
	        order: 'descending'
	      }
	    },
	    on: {
	      "row-click": _vm.selectedRow
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "label": " ",
	      "width": "100"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('div', {
	          staticStyle: {
	            "padding": "0.5em"
	          }
	        }, [(_vm.clients[scope.row.clientId]) ? _c('div', {
	          staticClass: "profile-row-photo",
	          attrs: {
	            "span": 4
	          }
	        }, [_c('img', {
	          attrs: {
	            "src": _vm.photosUrl(scope.row.clientId)
	          }
	        })]) : _c('div', {
	          staticClass: "profile-row-photo",
	          attrs: {
	            "span": 4
	          }
	        }, [_c('img', {
	          attrs: {
	            "src": __webpack_require__(10)
	          }
	        })])])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "sortable": "",
	      "fixed": "",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(_vm.clients[scope.row.clientId]) ? _c('span', [_vm._v(_vm._s(_vm.clientName(scope.row))), _c('br'), _vm._v("(" + _vm._s(_vm.clients[scope.row.clientId].patientId) + ")")]) : _c('span', [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Gender",
	      "width": "140"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(scope.row.gender) ? _c('span', [_vm._v(_vm._s(scope.row.gender))]) : _c('span', [_vm._v("Not Entered")])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "DOB",
	      "prop": "dateOfBirth",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(scope.row.dateOfBirth) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(scope.row.dateOfBirth, 'DD-MM-YYYY')))]) : _c('span', [_vm._v("Not Entered")])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Infection Site",
	      "width": "140"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(scope.row.symptomType === 'GI') ? _c('span', {
	          staticClass: "color-code-label-0"
	        }) : (scope.row.symptomType === 'UTI') ? _c('span', {
	          staticClass: "color-code-label-2"
	        }) : _c('span', {
	          staticClass: "color-code-label-1"
	        }), _vm._v("\n          " + _vm._s(scope.row.symptomType) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Status",
	      "width": "80"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('img', {
	          staticClass: "symptom-status-image",
	          attrs: {
	            "src": _vm.statusImage(scope.row)
	          }
	        })]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Symptoms",
	      "min-width": "160"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return _vm._l((scope.row.symptoms), function(d) {
	          return _c('el-tag', {
	            key: d.id,
	            attrs: {
	              "type": _vm.tagType(d)
	            }
	          }, [_vm._v(_vm._s(d.displayText))])
	        })
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Precautions",
	      "min-width": "160"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(_vm.clients[scope.row.clientId]) ? _c('div', _vm._l((_vm.clients[scope.row.clientId].precautionDetails), function(d) {
	          return _c('el-tag', [_vm._v(_vm._s(_vm.precautionById(d.precautionId)))])
	        })) : _vm._e()]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Staff",
	      "min-width": "160"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(_vm.isStaff(_vm.clients[scope.row.clientId])) ? _c('span', [_vm._v("\n            Yes\n          ")]) : _c('span', [_vm._v("\n            No\n          ")])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Location",
	      "width": "160"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(_vm.unitById(scope.row.unitId)) + " / " + _vm._s(_vm.beds[scope.row.bedId]) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Origin",
	      "width": "200"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(_vm.originById(scope.row.origin)) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Organism",
	      "width": "220"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(_vm.organismById(scope.row.organismId)) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Treatment",
	      "width": "220"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(_vm.treatmentById(scope.row.treatmentId)) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Resolution",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(scope.row.resolved) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Family Notified",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(scope.row.familyNotified) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Next of Kin Notified",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(scope.row.nextOfNotified) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Physician Notified",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(scope.row.physicianNotified) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Updated",
	      "prop": "updated",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(_vm._f("moment")(scope.row.updated, 'DD-MM-YYYY')) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Created",
	      "prop": "created",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(_vm._f("moment")(scope.row.created, 'DD-MM-YYYY')) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "fixed": "right",
	      "label": "Onset Date",
	      "prop": "onSetDate",
	      "sortable": "",
	      "width": "140"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(_vm._f("moment")(scope.row.onSetDate, 'DD-MM-YYYY')) + "\n        ")]
	      }
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 240 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance-treatment"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Start Date",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "End Date",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Treatment",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Notes"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 241 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    staticClass: "input-boxes",
	    attrs: {
	      "xs": {
	        span: 20,
	        offset: 2
	      },
	      "sm": {
	        span: 16,
	        offset: 4
	      },
	      "md": {
	        span: 10,
	        offset: 6
	      },
	      "lg": {
	        span: 8,
	        offset: 8
	      }
	    }
	  }, [_c('div', {
	    staticClass: "line"
	  }), _vm._v(" "), _c('el-form', {
	    attrs: {
	      "label-width": "100px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Username"
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "input": function($event) {
	        _vm.username = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Password"
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pass),
	      expression: "pass"
	    }],
	    attrs: {
	      "type": "password"
	    },
	    domProps: {
	      "value": (_vm.pass)
	    },
	    on: {
	      "input": function($event) {
	        _vm.pass = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "large"
	    },
	    on: {
	      "click": _vm.login
	    }
	  }, [_vm._v("Login")])], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 242 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance-personal-info"
	  }, [_c('h2', [_vm._v("Resident Information")]), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("First Name: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.clientData.firstName) + "\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Middle Name: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.clientData.middleName) + "\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Last Name: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.clientData.lastName) + "\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Date of Birth: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.clientData.date_of_birth) + "\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Staff: ")])]), _vm._v(" "), (_vm.isStaff()) ? _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_vm._v("\n        Yes\n    ")]) : _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_vm._v("\n        No\n    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Gender: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Address 1: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Address 2: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('span', [_vm._v("City: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_vm._v(" \n    ")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('span', [_vm._v("Prov/State: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Postal Code: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('h2', {
	    staticStyle: {
	      "float": "left"
	    }
	  }, [_vm._v("Resident Notes")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "float": "right",
	      "margin-top": "0.83em"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addNewNote()
	      }
	    }
	  }, [_vm._v("+ New")])], 1), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.allNotes,
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Date",
	      "prop": "created",
	      "width": "120"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n          " + _vm._s(_vm._f("moment")(scope.row.created, 'DD-MM-YYYY')) + "\n        ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Content"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(scope.row.isNew) ? _c('div', [_c('el-input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (scope.row.content),
	            expression: "scope.row.content"
	          }],
	          attrs: {
	            "type": "textarea",
	            "autosize": "",
	            "placeholder": "Please input"
	          },
	          domProps: {
	            "value": (scope.row.content)
	          },
	          on: {
	            "input": function($event) {
	              scope.row.content = $event
	            }
	          }
	        })], 1) : _c('div', {
	          staticClass: "case-note-content"
	        }, [_vm._v(_vm._s(scope.row.content))])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Action",
	      "width": "150"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('el-button-group', [(scope.row.isNew) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              _vm.saveAction(scope.$index, scope.row)
	            }
	          }
	        }, [_vm._v("\n              Save\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.isNew) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              _vm.cancelAction(scope.$index, scope.row)
	            }
	          }
	        }, [_vm._v("\n              Cancel\n            ")]) : _vm._e()], 1)]
	      }
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance-case-detail"
	  }, [_c('div', {
	    staticClass: "dialog-case-detail"
	  }, [_c('div', {
	    staticClass: "clearfix",
	    slot: "header"
	  }, [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Name: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 14
	    }
	  }, [_vm._v(_vm._s(_vm.clientName()) + " (" + _vm._s(_vm.clientData.patientId) + ")")]), _vm._v(" "), (_vm.clientData) ? _c('div', {
	    staticClass: "profile-photo"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.userPhoto()
	    }
	  })]) : _c('div', {
	    staticClass: "profile-photo"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(10)
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Infection Site: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [(_vm.caseData.symptomType === 'GI') ? _c('span', {
	    staticClass: "color-code-label-0"
	  }) : (_vm.caseData.symptomType === 'UTI') ? _c('span', {
	    staticClass: "color-code-label-2"
	  }) : _c('span', {
	    staticClass: "color-code-label-1"
	  }), _vm._v("\n                " + _vm._s(_vm.caseData.symptomType) + "\n            ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Origin:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.origin),
	      expression: "caseData.origin"
	    }],
	    attrs: {
	      "placeholder": "Select"
	    },
	    domProps: {
	      "value": (_vm.caseData.origin)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.origin = $event
	      }
	    }
	  }, _vm._l((_vm.origins), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": _vm.originById(item.value),
	        "value": item.value
	      }
	    }, [_c('span', [_vm._v(_vm._s(_vm.originById(item.value)))])])
	  }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Onset Date:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-date-picker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.onSetDate),
	      expression: "caseData.onSetDate"
	    }],
	    attrs: {
	      "type": "date",
	      "readonly": "",
	      "editable": "",
	      "clearable": "",
	      "format": "dd-MM-yyyy"
	    },
	    domProps: {
	      "value": (_vm.caseData.onSetDate)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.onSetDate = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Symptoms:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, _vm._l((_vm.caseData.symptoms), function(d) {
	    return _c('el-tag', {
	      key: d.id,
	      attrs: {
	        "type": _vm.tagType(d)
	      }
	    }, [_vm._v(_vm._s(d.displayText))])
	  }))], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Confirmed:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 10
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.confirmed),
	      expression: "caseData.confirmed"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.caseData.confirmed)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.confirmed = $event
	      }
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "symptom-detail-status-image",
	    attrs: {
	      "src": _vm.statusImage(_vm.caseData)
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Primary Organism:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.organismId),
	      expression: "caseData.organismId"
	    }],
	    attrs: {
	      "filterable": "",
	      "placeholder": "Not Selected"
	    },
	    domProps: {
	      "value": (_vm.caseData.organismId)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.organismId = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Not Selected",
	      "value": 0
	    }
	  }), _vm._v(" "), _vm._l((_vm.organisms), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "float": "right",
	        "color": "#8492a6",
	        "font-size": "13px"
	      }
	    }, [_vm._v(_vm._s(item.value))])])
	  })], 2)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Treatment:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.treatmentId),
	      expression: "caseData.treatmentId"
	    }],
	    attrs: {
	      "filterable": "",
	      "placeholder": "Not Selected"
	    },
	    domProps: {
	      "value": (_vm.caseData.treatmentId)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.treatmentId = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Not Selected",
	      "value": 0
	    }
	  }), _vm._v(" "), _vm._l((_vm.treatments), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.displayText,
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.displayText))])])
	  })], 2)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Notification:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-checkbox', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.familyNotified),
	      expression: "caseData.familyNotified"
	    }],
	    domProps: {
	      "value": (_vm.caseData.familyNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.familyNotified = $event
	      }
	    }
	  }, [_vm._v("Family Notified")])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 7
	    }
	  }, [_c('el-checkbox', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.nextOfNotified),
	      expression: "caseData.nextOfNotified"
	    }],
	    domProps: {
	      "value": (_vm.caseData.nextOfNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.nextOfNotified = $event
	      }
	    }
	  }, [_vm._v("Next of Kin Notified")])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-checkbox', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.physicianNotified),
	      expression: "caseData.physicianNotified"
	    }],
	    domProps: {
	      "value": (_vm.caseData.physicianNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.physicianNotified = $event
	      }
	    }
	  }, [_vm._v("Physician Notified")])], 1)], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 100
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 16,
	      "offset": 4
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchNameInput),
	      expression: "searchNameInput"
	    }],
	    attrs: {
	      "placeholder": "Search by Name"
	    },
	    domProps: {
	      "value": (_vm.searchNameInput)
	    },
	    on: {
	      "input": function($event) {
	        _vm.searchNameInput = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 100
	    }
	  }, _vm._l((_vm.nameFilter(_vm.cases)), function(o, index) {
	    return _c('el-col', {
	      attrs: {
	        "span": 16,
	        "offset": 4
	      }
	    }, [_c('el-card', [_c('div', {
	      staticStyle: {
	        "padding": "14px"
	      }
	    }, [_c('div', {
	      staticClass: "clearfix",
	      slot: "header"
	    }, [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('span', [_vm._v("Name: ")])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 12
	      }
	    }, [_vm._v(_vm._s(o.name))]), _vm._v(" "), (_vm.photos[o.clientId]) ? _c('el-col', {
	      staticClass: "profile-photo",
	      attrs: {
	        "span": 4
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.photos[o.clientId]
	      }
	    })]) : _c('el-col', {
	      staticClass: "profile-photo",
	      attrs: {
	        "span": 4
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": __webpack_require__(10)
	      }
	    })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('span', [_vm._v("Infection Site: ")])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 16
	      }
	    }, [_vm._v(_vm._s(o.symptomType) + "\n                  "), (o.symptomType === 'GI') ? _c('span', {
	      staticClass: "color-code-label-0"
	    }) : (o.symptomType === 'UTI') ? _c('span', {
	      staticClass: "color-code-label-2"
	    }) : _c('span', {
	      staticClass: "color-code-label-1"
	    })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_vm._v("Organism:")]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 16
	      }
	    }, [_c('el-dropdown', [_c('span', {
	      staticClass: "el-dropdown-link"
	    }, [_vm._v("\n                      Not Selected"), _c('i', {
	      staticClass: "el-icon-caret-bottom el-icon--right"
	    })]), _vm._v(" "), _c('el-dropdown-menu', {
	      slot: "dropdown"
	    }, [_c('el-dropdown-item', [_vm._v("Organism 1")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("Organism 2")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("Organism 3")]), _vm._v(" "), _c('el-dropdown-item', {
	      attrs: {
	        "divided": ""
	      }
	    }, [_vm._v("Organism 4")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("Organism 5")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_vm._v("Origin:")]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 16
	      }
	    }, [_c('el-select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (o.origin),
	        expression: "o.origin"
	      }],
	      attrs: {
	        "placeholder": "Select"
	      },
	      domProps: {
	        "value": (o.origin)
	      },
	      on: {
	        "input": function($event) {
	          o.origin = $event
	        }
	      }
	    }, _vm._l((_vm.origins), function(item) {
	      return _c('el-option', {
	        attrs: {
	          "label": item.label,
	          "value": item.value
	        }
	      })
	    }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_vm._v("Onset Date:")]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 16
	      }
	    }, [_c('el-date-picker', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (o.onSetDate),
	        expression: "o.onSetDate"
	      }],
	      attrs: {
	        "type": "date",
	        "readonly": "",
	        "editable": "",
	        "clearable": "",
	        "format": "dd-MM-yyyy"
	      },
	      domProps: {
	        "value": (o.onSetDate)
	      },
	      on: {
	        "input": function($event) {
	          o.onSetDate = $event
	        }
	      }
	    })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_vm._v("Symptoms:")]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 16
	      }
	    }, _vm._l((o.symptoms), function(d) {
	      return _c('el-tag', {
	        key: d.id,
	        attrs: {
	          "type": _vm.tagType(d)
	        }
	      }, [_vm._v(_vm._s(d.displayText))])
	    }))], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_vm._v("Norification:")]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 5
	      }
	    }, [_c('el-checkbox', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (o.familyNotified),
	        expression: "o.familyNotified"
	      }],
	      domProps: {
	        "value": (o.familyNotified)
	      },
	      on: {
	        "input": function($event) {
	          o.familyNotified = $event
	        }
	      }
	    }, [_vm._v("Family Notified")])], 1), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 5
	      }
	    }, [_c('el-checkbox', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (o.nextOfNotified),
	        expression: "o.nextOfNotified"
	      }],
	      domProps: {
	        "value": (o.nextOfNotified)
	      },
	      on: {
	        "input": function($event) {
	          o.nextOfNotified = $event
	        }
	      }
	    }, [_vm._v("Next of Kin Notified")])], 1), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 5
	      }
	    }, [_c('el-checkbox', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (o.physicianNotified),
	        expression: "o.physicianNotified"
	      }],
	      domProps: {
	        "value": (o.physicianNotified)
	      },
	      on: {
	        "input": function($event) {
	          o.physicianNotified = $event
	        }
	      }
	    }, [_vm._v("Physician Notified")])], 1)], 1)], 1)])], 1)
	  }))], 1)
	},staticRenderFns: []}

/***/ },
/* 245 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance-symptoms"
	  }, [_c('div', {
	    staticClass: "clearfix",
	    slot: "header"
	  }, [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Infection Site/Type: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 14
	    }
	  }, [_vm._v(_vm._s(_vm.caseData.symptomType) + " - \n        "), _c('el-tooltip', {
	    staticClass: "item",
	    attrs: {
	      "effect": "dark",
	      "content": _vm.symptomDetail(_vm.caseData.symptomType),
	      "placement": "bottom"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("View Details")])])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Symptoms Exhibited: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "border": "",
	      "data": _vm.caseData.symptoms,
	      "default-sort": {
	        prop: 'created',
	        order: 'descending'
	      }
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "On Set Date",
	      "width": "120"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n                    " + _vm._s(_vm._f("moment")(scope.row.onSetDate, 'DD-MM-YYYY')) + "\n                  ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Symptom"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('div', {
	          staticClass: "case-note-content"
	        }, [_vm._v(_vm._s(scope.row.displayText))])]
	      }
	    }
	  })], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 246 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.loggedIn()) ? _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    staticClass: "top-menu"
	  }, [_c('el-menu', {
	    staticClass: "infc-menu",
	    attrs: {
	      "mode": "horizontal"
	    },
	    on: {
	      "open": _vm.handleTopOpen
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/ckmlogo.png"
	    }
	  })]), _vm._v(" "), (_vm.loggedIn()) ? _c('el-menu-item', {
	    staticClass: "infc-logout-button",
	    attrs: {
	      "index": "1"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_vm._v("Log Out")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.loggedIn()) ? _c('div', {
	    staticClass: "left-sub-menu"
	  }, [_c('el-menu', {
	    staticClass: "el-menu-vertical",
	    attrs: {
	      "default-active": _vm.activeIndex,
	      "theme": "dark",
	      "router": true
	    },
	    on: {
	      "open": _vm.handleOpen,
	      "close": _vm.handleClose
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "/"
	    }
	  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('el-menu-item', {
	    attrs: {
	      "index": "/surveillance"
	    }
	  }, [_vm._v("Infection Surveillance")]), _vm._v(" "), _c('el-menu-item-group', {
	    attrs: {
	      "title": "Outbreak Management"
	    }
	  }), _vm._v(" "), _c('el-menu-item-group', {
	    attrs: {
	      "title": "Infection Threshold"
	    }
	  }), _vm._v(" "), _c('el-menu-item-group', {
	    attrs: {
	      "title": "Infection Analysis"
	    }
	  }), _vm._v(" "), _c('el-menu-item-group', {
	    attrs: {
	      "title": "Denominators"
	    }
	  }), _vm._v(" "), _c('el-submenu', [_c('template', {
	    slot: "title"
	  }, [_c('i', {
	    staticClass: "el-icon-setting"
	  }), _vm._v("Setup")]), _vm._v(" "), _c('el-menu-item', {
	    attrs: {
	      "index": "/clients"
	    }
	  }, [_vm._v("Residents")])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "right-content"
	  }, [_c('router-view')], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "splash"
	  }, [_c('div', {
	    staticClass: "filter"
	  }, [_c('div', {
	    staticClass: "section-header"
	  }, [_c('el-row', [_c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), _c('el-row', {
	    staticClass: "filter-section"
	  }, [_c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Date Range")]), _vm._v(" "), _c('el-date-picker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filterDateRange),
	      expression: "filterDateRange"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "label": "Date Range",
	      "type": "daterange",
	      "placeholder": "Date Range",
	      "format": "dd-MM-yyyy",
	      "range-separator": " ~ ",
	      "picker-options": _vm.pickerOptions,
	      "clearable": false,
	      "small": ""
	    },
	    domProps: {
	      "value": (_vm.filterDateRange)
	    },
	    on: {
	      "change": _vm.dateRangeUpdated,
	      "input": function($event) {
	        _vm.filterDateRange = $event
	      }
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_vm._v("Http://")])], 2)], 1), _vm._v(" "), _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Unit")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedUnit),
	      expression: "selectedUnit"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Unit"
	    },
	    domProps: {
	      "value": (_vm.selectedUnit)
	    },
	    on: {
	      "change": _vm.unitUpdated,
	      "input": function($event) {
	        _vm.selectedUnit = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All Units",
	      "value": 0
	    }
	  }), _vm._v(" "), _vm._l((_vm.units), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.displayText,
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.displayText))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "float": "right",
	        "color": "#8492a6",
	        "font-size": "13px"
	      }
	    }, [_vm._v(_vm._s(item.value))])])
	  })], 2)], 1), _vm._v(" "), _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Infection Site")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filteredSite),
	      expression: "filteredSite"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Select Infection Site"
	    },
	    domProps: {
	      "value": (_vm.filteredSite)
	    },
	    on: {
	      "change": _vm.symptomTypeUpdated,
	      "input": function($event) {
	        _vm.filteredSite = $event
	      }
	    }
	  }, _vm._l((_vm.symptomTypes), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.text,
	        "value": item.value
	      }
	    })
	  }))], 1), _vm._v(" "), _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Origin")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedOrigin),
	      expression: "selectedOrigin"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Origin"
	    },
	    domProps: {
	      "value": (_vm.selectedOrigin)
	    },
	    on: {
	      "change": _vm.originUpdated,
	      "input": function($event) {
	        _vm.selectedOrigin = $event
	      }
	    }
	  }, _vm._l((_vm.origins), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }))], 1), _vm._v(" "), _c('label', [_c('span', {
	    staticClass: "filter-title-label"
	  }, [_vm._v("Status")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedStatus),
	      expression: "selectedStatus"
	    }],
	    staticClass: "filter-section-input",
	    attrs: {
	      "placeholder": "Status"
	    },
	    domProps: {
	      "value": (_vm.selectedStatus)
	    },
	    on: {
	      "change": _vm.confirmStatusUpdated,
	      "input": function($event) {
	        _vm.selectedStatus = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "All",
	      "value": 0
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Confirmed",
	      "value": 1
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Suspected",
	      "value": 2
	    }
	  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "section-header"
	  }, [_c('el-row', [_vm._v("\n      Case Frequency\n      "), _c('div', {
	    staticClass: "graph-filter"
	  }, [_c('el-radio-group', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.graphPeriodFilter),
	      expression: "graphPeriodFilter"
	    }],
	    attrs: {
	      "size": "small"
	    },
	    domProps: {
	      "value": (_vm.graphPeriodFilter)
	    },
	    on: {
	      "input": function($event) {
	        _vm.graphPeriodFilter = $event
	      }
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "By Year"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "By Quarter"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "By Month"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "By Week"
	    }
	  })], 1), _vm._v(" "), _c('el-radio-group', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.graphDisplayFilter),
	      expression: "graphDisplayFilter"
	    }],
	    attrs: {
	      "size": "small"
	    },
	    domProps: {
	      "value": (_vm.graphDisplayFilter)
	    },
	    on: {
	      "input": function($event) {
	        _vm.graphDisplayFilter = $event
	      }
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "By Unit"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "By Infection Site"
	    }
	  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "graph"
	  }, [_c('inf-case-graph', {
	    attrs: {
	      "range": _vm.filterDateRange,
	      "period": _vm.filterPeriods,
	      "sites": _vm.filterSymptomTypes,
	      "origin": _vm.filterOrigin,
	      "confirmed": _vm.filterConfirmStatus,
	      "config": _vm.graphConfig,
	      "mode": _vm.graphMode,
	      "unitId": _vm.selectedUnit
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "section-header"
	  }, [_c('el-row', [_c('span', [_vm._v("Case Detail")]), _vm._v(" "), _c('div', {
	    staticClass: "case-filter"
	  }, [_c('el-button', {
	    staticClass: "case-export-button",
	    attrs: {
	      "plain": true,
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": function($event) {
	        _vm.exportExcel()
	      }
	    }
	  }, [_vm._v("Export Data")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.symptomDetailPageSize),
	      expression: "symptomDetailPageSize"
	    }],
	    staticClass: "case-page-size-filter",
	    attrs: {
	      "size": "mini",
	      "placeholder": "Choose tags for your article"
	    },
	    domProps: {
	      "value": (_vm.symptomDetailPageSize)
	    },
	    on: {
	      "input": function($event) {
	        _vm.symptomDetailPageSize = $event
	      }
	    }
	  }, _vm._l((_vm.symptomDetailPageSizeOptions), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  })), _vm._v(" "), _c('el-pagination', {
	    attrs: {
	      "small": "",
	      "layout": "prev, pager, next",
	      "current-page": _vm.symptomDetailPage,
	      "page-count": _vm.symptomDetailPageTotal
	    },
	    on: {
	      "current-change": _vm.reloadPage
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.selectedCase) ? _c('el-dialog', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dialogFormVisible),
	      expression: "dialogFormVisible"
	    }],
	    attrs: {
	      "title": "Case Detail"
	    },
	    domProps: {
	      "value": (_vm.dialogFormVisible)
	    },
	    on: {
	      "input": function($event) {
	        _vm.dialogFormVisible = $event
	      }
	    }
	  }, [_c('surveillance-case-detail', {
	    attrs: {
	      "caseData": _vm.selectedCase,
	      "clientData": _vm.clients[_vm.selectedCase.clientId],
	      "origins": _vm.origins,
	      "organisms": _vm.organisms,
	      "treatments": _vm.treatments
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.saveSymtomDetail(_vm.selectedCase)
	      }
	    }
	  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogFormVisible = false;
	        this.selectedCase = null
	      }
	    }
	  }, [_vm._v("Close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loadingData),
	      expression: "loadingData",
	      modifiers: {
	        "body": true
	      }
	    }],
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.cases,
	      "default-sort": {
	        prop: 'onSetDate',
	        order: 'descending'
	      }
	    },
	    on: {
	      "row-click": _vm.selectedRow
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "label": " ",
	      "width": "100"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('div', {
	          staticStyle: {
	            "padding": "0.5em"
	          }
	        }, [(_vm.clients[scope.row.clientId]) ? _c('div', {
	          staticClass: "profile-row-photo",
	          attrs: {
	            "span": 4
	          }
	        }, [_c('img', {
	          attrs: {
	            "src": _vm.photosUrl(scope.row.clientId)
	          }
	        })]) : _c('div', {
	          staticClass: "profile-row-photo",
	          attrs: {
	            "span": 4
	          }
	        }, [_c('img', {
	          attrs: {
	            "src": __webpack_require__(10)
	          }
	        })])])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "sortable": "",
	      "fixed": "",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(_vm.clients[scope.row.clientId]) ? _c('span', [_vm._v(_vm._s(_vm.clientName(scope.row))), _c('br'), _vm._v("(" + _vm._s(_vm.clients[scope.row.clientId].patientId) + ")")]) : _c('span', [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Infection Site",
	      "width": "140"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(scope.row.symptomType === 'GI') ? _c('span', {
	          staticClass: "color-code-label-0"
	        }) : (scope.row.symptomType === 'UTI') ? _c('span', {
	          staticClass: "color-code-label-2"
	        }) : _c('span', {
	          staticClass: "color-code-label-1"
	        }), _vm._v("\n        " + _vm._s(scope.row.symptomType) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Status",
	      "width": "80"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('img', {
	          staticClass: "symptom-status-image",
	          attrs: {
	            "src": _vm.statusImage(scope.row)
	          }
	        })]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Symptoms",
	      "min-width": "160"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return _vm._l((scope.row.symptoms), function(d) {
	          return _c('el-tag', {
	            key: d.id,
	            attrs: {
	              "type": _vm.tagType(d)
	            }
	          }, [_vm._v(_vm._s(d.displayText))])
	        })
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Precautions",
	      "min-width": "160"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(_vm.clients[scope.row.clientId]) ? _c('div', _vm._l((_vm.clients[scope.row.clientId].precautionDetails), function(d) {
	          return _c('el-tag', [_vm._v(_vm._s(_vm.precautionById(d.precautionId)))])
	        })) : _vm._e()]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Location",
	      "width": "160"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(_vm.unitById(scope.row.unitId)) + " / " + _vm._s(_vm.beds[scope.row.bedId]) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Origin",
	      "width": "200"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(_vm.originById(scope.row.origin)) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Organism",
	      "width": "220"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(_vm.organismById(scope.row.organismId)) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Treatment",
	      "width": "220"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(_vm.treatmentById(scope.row.treatmentId)) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "fixed": "right",
	      "label": "Onset Date",
	      "prop": "onSetDate",
	      "sortable": "",
	      "width": "140"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(_vm._f("moment")(scope.row.onSetDate, 'DD-MM-YYYY')) + "\n      ")]
	      }
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 248 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance-biology"
	  }, [_c('el-table', {
	    attrs: {
	      "data": _vm.biologyInfo
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "width": "130"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(scope.row.label) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "date",
	      "label": "Organism",
	      "width": "200"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('el-select', {
	          attrs: {
	            "placeholder": "Not Selected"
	          }
	        }, _vm._l((_vm.organisms), function(item) {
	          return _c('el-option', {
	            attrs: {
	              "label": item.name,
	              "value": item.id
	            }
	          }, [_c('span', {
	            staticStyle: {
	              "float": "left"
	            }
	          }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
	            staticStyle: {
	              "float": "right",
	              "color": "#8492a6",
	              "font-size": "13px"
	            }
	          }, [_vm._v(_vm._s(item.value))])])
	        }))]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Antibiotic Sensitivity"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('el-select', {
	          attrs: {
	            "placeholder": "Not Selected"
	          }
	        })]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column')], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "symptom-case-detail"
	  }, [_c('div', {
	    staticClass: "dialog-case-detail"
	  }, [_c('div', {
	    staticClass: "clearfix",
	    slot: "header"
	  }, [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Name: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 14
	    }
	  }, [_vm._v(_vm._s(_vm.clientData.name) + " (" + _vm._s(_vm.clientData.patientId) + ")")]), _vm._v(" "), (_vm.client) ? _c('div', {
	    staticClass: "profile-photo"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.photoUrl()
	    }
	  })]) : _c('div', {
	    staticClass: "profile-photo"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(10)
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_c('span', [_vm._v("Infection Site: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [(_vm.caseData.symptomType === 'GI') ? _c('span', {
	    staticClass: "color-code-label-0"
	  }) : (_vm.caseData.symptomType === 'UTI') ? _c('span', {
	    staticClass: "color-code-label-2"
	  }) : _c('span', {
	    staticClass: "color-code-label-1"
	  }), _vm._v("\n                " + _vm._s(_vm.caseData.symptomType) + "\n            ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Origin:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.origin),
	      expression: "caseData.origin"
	    }],
	    attrs: {
	      "placeholder": "Select"
	    },
	    domProps: {
	      "value": (_vm.caseData.origin)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.origin = $event
	      }
	    }
	  }, _vm._l((_vm.origins), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": _vm.originById(item.value),
	        "value": item.value
	      }
	    }, [_c('span', [_vm._v(_vm._s(_vm.originById(item.value)))])])
	  }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Onset Date:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-date-picker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.onSetDate),
	      expression: "caseData.onSetDate"
	    }],
	    attrs: {
	      "type": "date",
	      "readonly": "",
	      "editable": "",
	      "clearable": "",
	      "format": "dd-MM-yyyy"
	    },
	    domProps: {
	      "value": (_vm.caseData.onSetDate)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.onSetDate = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Symptoms:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, _vm._l((_vm.caseData.symptoms), function(d) {
	    return _c('el-tag', {
	      key: d.id,
	      attrs: {
	        "type": _vm.tagType(d)
	      }
	    }, [_vm._v(_vm._s(d.displayText))])
	  }))], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Confirmed:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 10
	    }
	  }, [_c('el-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.confirmed),
	      expression: "caseData.confirmed"
	    }],
	    attrs: {
	      "on-text": "YES",
	      "off-text": "NO",
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    domProps: {
	      "value": (_vm.caseData.confirmed)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.confirmed = $event
	      }
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "symptom-detail-status-image",
	    attrs: {
	      "src": _vm.statusImage(_vm.caseData)
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Organism:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.organismId),
	      expression: "caseData.organismId"
	    }],
	    attrs: {
	      "filterable": "",
	      "placeholder": "Not Selected"
	    },
	    domProps: {
	      "value": (_vm.caseData.organismId)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.organismId = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Not Selected",
	      "value": 0
	    }
	  }), _vm._v(" "), _vm._l((_vm.organisms), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "float": "right",
	        "color": "#8492a6",
	        "font-size": "13px"
	      }
	    }, [_vm._v(_vm._s(item.value))])])
	  })], 2)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Treatment:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 16
	    }
	  }, [_c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.treatmentId),
	      expression: "caseData.treatmentId"
	    }],
	    attrs: {
	      "filterable": "",
	      "placeholder": "Not Selected"
	    },
	    domProps: {
	      "value": (_vm.caseData.treatmentId)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.treatmentId = $event
	      }
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Not Selected",
	      "value": 0
	    }
	  }), _vm._v(" "), _vm._l((_vm.treatments), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.displayText,
	        "value": item.id
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.displayText))])])
	  })], 2)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Notification:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-checkbox', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.familyNotified),
	      expression: "caseData.familyNotified"
	    }],
	    domProps: {
	      "value": (_vm.caseData.familyNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.familyNotified = $event
	      }
	    }
	  }, [_vm._v("Family Notified")])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 7
	    }
	  }, [_c('el-checkbox', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.nextOfNotified),
	      expression: "caseData.nextOfNotified"
	    }],
	    domProps: {
	      "value": (_vm.caseData.nextOfNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.nextOfNotified = $event
	      }
	    }
	  }, [_vm._v("Next of Kin Notified")])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-checkbox', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caseData.physicianNotified),
	      expression: "caseData.physicianNotified"
	    }],
	    domProps: {
	      "value": (_vm.caseData.physicianNotified)
	    },
	    on: {
	      "input": function($event) {
	        _vm.caseData.physicianNotified = $event
	      }
	    }
	  }, [_vm._v("Physician Notified")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 5
	    }
	  }, [_vm._v("Notes:")]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 19
	    }
	  }, [_c('div', {
	    staticClass: "case-note"
	  }, [(_vm.caseData.notes.length <= 0) ? _c('div', [_c('div', {
	    staticClass: "case-note-date"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "case-note-content-empty"
	  }, [_vm._v("Not Available")])]) : _vm._l((_vm.caseData.notes.slice().reverse()), function(d) {
	    return _c('div', [_c('div', {
	      staticClass: "case-note-date"
	    }, [_vm._v(_vm._s(_vm._f("moment")(d.created, 'DD-MM-YYYY')))]), _vm._v(" "), _c('div', {
	      staticClass: "case-note-content"
	    }, [_vm._v(_vm._s(d.content))])])
	  })], 2)])], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 250 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance-device"
	  }, [_c('el-table', {
	    attrs: {
	      "data": _vm.deviceInfo
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "width": "120"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(scope.row.label) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Usage",
	      "width": "200"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('el-select', {
	          attrs: {
	            "placeholder": "Not Selected"
	          }
	        })]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "220",
	      "label": "Start Date"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('el-date-picker', {
	          attrs: {
	            "type": "date",
	            "readonly": "",
	            "editable": "",
	            "clearable": "",
	            "format": "dd-MM-yyyy"
	          }
	        })]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "220",
	      "label": "End Date"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('el-date-picker', {
	          attrs: {
	            "type": "date",
	            "readonly": "",
	            "editable": "",
	            "clearable": "",
	            "format": "dd-MM-yyyy"
	          }
	        })]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Duration"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "clients"
	  }, [_c('div', {
	    staticClass: "filter"
	  }, [_c('div', {
	    staticClass: "section-header"
	  }, [_c('el-row', [_c('span', [_vm._v("Residents: " + _vm._s(_vm.clients.length))])])], 1)]), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.clients,
	      "default-sort": {
	        prop: 'onSetDate',
	        order: 'descending'
	      }
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "label": " ",
	      "width": "100"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('div', {
	          staticStyle: {
	            "padding": "0.5em"
	          }
	        }, [(scope.row.photo) ? _c('div', {
	          staticClass: "profile-row-photo",
	          attrs: {
	            "span": 4
	          }
	        }, [_c('img', {
	          attrs: {
	            "src": _vm.photoUrl(scope.row.photo)
	          }
	        })]) : _c('div', {
	          staticClass: "profile-row-photo",
	          attrs: {
	            "span": 4
	          }
	        }, [_c('img', {
	          attrs: {
	            "src": __webpack_require__(10)
	          }
	        })])])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "sortable": "",
	      "fixed": "",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(_vm.clientName(scope.row)) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Gender",
	      "width": "140"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(scope.row.gender) ? _c('span', [_vm._v(_vm._s(scope.row.gender))]) : _c('span', [_vm._v("Not Entered")])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "DOB",
	      "prop": "dateOfBirth",
	      "width": "180"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(scope.row.dateOfBirth) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(scope.row.dateOfBirth, 'DD-MM-YYYY')))]) : _c('span', [_vm._v("Not Entered")])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Location"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(_vm.beds[scope.row.id]) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.unitById(scope.row.unitId)) + " / " + _vm._s(_vm.beds[scope.row.id].displayText) + "\n        ")]) : _c('span', [_vm._v("\n        Not Assigned\n        ")])]
	      }
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 252 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('button', {
	    staticClass: "export_button",
	    on: {
	      "click": function($event) {
	        _vm.exportGraph()
	      }
	    }
	  }, [_vm._v("Export Graph")])])
	},staticRenderFns: []}

/***/ },
/* 253 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance-communication"
	  }, [_c('el-row', {
	    attrs: {
	      "type": "flex",
	      "justify": "end"
	    }
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.addNewNote()
	      }
	    }
	  }, [_vm._v("+ New")])], 1), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "margin-top": "1em"
	    },
	    attrs: {
	      "border": "",
	      "data": _vm.allNotes,
	      "default-sort": {
	        prop: 'created',
	        order: 'descending'
	      }
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Date",
	      "prop": "created",
	      "width": "120"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_vm._v("\n        " + _vm._s(_vm._f("moment")(scope.row.created, 'DD-MM-YYYY')) + "\n      ")]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Content"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [(scope.row.isNew) ? _c('div', [_c('el-input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (scope.row.content),
	            expression: "scope.row.content"
	          }],
	          attrs: {
	            "type": "textarea",
	            "autosize": "",
	            "placeholder": "Please input"
	          },
	          domProps: {
	            "value": (scope.row.content)
	          },
	          on: {
	            "input": function($event) {
	              scope.row.content = $event
	            }
	          }
	        })], 1) : _c('div', {
	          staticClass: "case-note-content"
	        }, [_vm._v(_vm._s(scope.row.content))])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Action",
	      "width": "150"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('el-button-group', [(scope.row.isNew) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              _vm.saveAction(scope.$index, scope.row)
	            }
	          }
	        }, [_vm._v("\n            Save\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.isNew) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              _vm.cancelAction(scope.$index, scope.row)
	            }
	          }
	        }, [_vm._v("\n            Cancel\n          ")]) : _vm._e()], 1)]
	      }
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 254 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "surveillance-precaution"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.clientData.precautionDetails,
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Precaution"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return [_c('div', {
	          staticClass: "case-note-content"
	        }, [_vm._v(_vm._s(_vm.precautionById(scope.row.precautionId)))])]
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Start Date",
	      "prop": "created",
	      "width": "120"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return void 0
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "End Date",
	      "prop": "created",
	      "width": "120"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return void 0
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Unit",
	      "prop": "created",
	      "width": "120"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return void 0
	      }
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Room",
	      "prop": "created",
	      "width": "120"
	    },
	    scopedSlots: {
	      default: function(scope) {
	        return void 0
	      }
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.a981fb722636d70887a0.js